<template>
  <div>
    <!-- <Cabecera></Cabecera> -->
    <main role="main">
      <!-- <StepNumbers></StepNumbers> -->
      <div class="c-steps-numbers">
        <div class="container">
          <div class="c-steps-numbers__item success">
            <span>1</span>
            <p>Información y<br />antecedentes legales</p>
          </div>
          <div class="c-steps-numbers__item active">
            <span>2</span>
            <p>Antecedentes<br />financieros</p>
          </div>
          <div class="c-steps-numbers__item">
            <span>3</span>
            <p>Patrocinios</p>
          </div>
          <div class="c-steps-numbers__item">
            <span>4</span>
            <p>Participación</p>
          </div>
          <div class="c-steps-numbers__item">
            <span>5</span>
            <p>Declaraciones<br />y compromisos</p>
          </div>
        </div>
      </div>
      <div class="c-form-steps">
        <!-- <div class="requestNumber">
            <p>SOLICITUD N° {{globalRequestNumber}}</p>
        </div> -->
        <div class="c-form-steps__sections" data-step="02">
          <div class="container u-pb0">
            <div class="c-form-steps__content step-data">
              <div class="row">
                <div class="col-md-12 col-lg-6 offset-lg-2">
                  <h2>Información de los Trabajadores</h2>
                  <p>
                    Ingresa el número de la totalidad de sus trabajadores,
                    incluyendo los que están en obra, faena o centro de trabajo.
                  </p>

                  <form action="#" id="step04_1">
                    <!-- <div class="input u-mb0">
                      <label>Número total de trabajadores en la empresa</label>
                      <input type="text" name="trabajadores_st04">
                    </div> -->
                    <label>Número total de trabajadores en la empresa</label>
                    <div class="input u-mb0">
                      <div class="input-select">
                        <select
                          tabindex="1"
                          name="trabajadores_st03"
                          @input="
                            $event = setTotalEmployees($event.target.value)
                          "
                          :value="selectedTotalEmployees"
                          @change="employeesTotalValidation()"
                          :disabled="!this.corregir"
                        >
                          <!-- <option value="" selected disabled hidden>
                            Número total de trabajadores en la empresa
                          </option> -->
                          <option
                            v-for="(employees, key) in totalEmployees"
                            :value="employees.num_Trabajadores_Id"
                            :key="key"
                          >
                            {{ employees.numero_trabajadores }}
                          </option>
                        </select>
                        <div
                          id="giro_st03-error"
                          class="errorlogin"
                          v-if="totalEmployeesIsValid === false"
                        >
                          Ingrese un número de trabajadores
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="c-form-drag">
            <div class="container">
              <div class="row">
                <div class="col-md-12 col-lg-6 offset-lg-2">
                  <h2>Información Financiera</h2>
                  <form action="#" id="step04_2">
                    <!-- <div class="input u-mb60">
                      <div class="input-select">
                        <select name="rangofacturacion_st04">
                          <option value="default">Rango de facturación según ventas anuales</option>
                        </select>
                      </div>
                    </div> -->
                    <label>Rango de facturación según ventas anuales</label>
                    <div class="input u-mb60">
                      <div class="input-select">
                        <select
                          tabindex="2"
                          name="rango_st03"
                          @input="$event = setRange($event.target.value)"
                          :value="selectedRange"
                          @change="rangeValidation()"
                          :disabled="!this.corregir"
                        >
                          <!-- <option value="" selected disabled>
                            Rango de facturación según ventas anuales
                          </option> -->
                          <option
                            v-for="(range, key) in range"
                            :value="range.rangoId"
                            :key="key"
                          >
                            {{ range.rango }}
                          </option>
                        </select>
                        <div
                          id="giro_st03-error"
                          class="errorlogin"
                          v-if="rangeIsValid === false"
                        >
                          Ingrese un rango
                        </div>
                      </div>
                    </div>
                    <div class="input u-mb60 uf" ref="input">
                      <!-- <div class="input-select">
                        <select name="patrimonio_st04">
                          <option value="default">Patrimonio según último balance o capital inicial para empresas < 1 año</option>
                        </select>
                      </div> -->
                      <label
                        >Patrimonio según último balance o capital inicial para
                        empresas < 1 año</label
                      >
                      <input
                        type="text"
                        name="patrimonio_st04"
                        ref="percentage"
                        tabindex="3"
                        maxlength="10"
                        pattern="\d{1,7}(?:\.\d{0,2})?$"
                        v-model="firstPercentage"
                        @focus="focusUF($refs.input)"
                        @blur="blurUF([$refs.input, $refs.percentage.value])"
                        @keyup="
                          firstPercentageValidation($refs.percentage.value)
                        "
                        :disabled="!this.corregir"
                      />
                      <div
                        id="porcentaje-error"
                        class="errorlogin"
                        v-if="firstPercentageIsValid === false"
                      >
                        Ingresar UF (Se aceptan solamente 7 enteros y 2
                        decimales. 123456,12)
                      </div>
                    </div>
                    <div class="input u-mb60 percent" ref="society">
                      <label
                        >Porcentaje del negocio dedicado o vinculado al rubro de
                        la construcción <br
                      /></label>
                      <input
                        type="text"
                        name="porcentajesociedad_st04"
                        tabindex="4"
                        ref="build"
                        v-model="secondPercentage"
                        @input="acceptNumberSecond"
                        @focus="focusPercentage($refs.society)"
                        @blur="
                          blurPercentage([$refs.society, $refs.build.value])
                        "
                        @keyup="secondPercentageValidation()"
                        :disabled="!this.corregir"
                      />
                      <div
                        id="porcentaje-error"
                        class="errorlogin"
                        v-if="secondPercentageIsValid === false"
                      >
                        Ingrese un Porcentaje
                      </div>
                    </div>
                    <div class="input u-mb30 uf" ref="volume">
                      <label class="uf">Volumen facturado año anterior</label>
                      <input
                        type="text"
                        name="volumenfacturacion_st04"
                        ref="volumeInput"
                        tabindex="5"
                        maxlength="7"
                        v-model="volume"
                        :disabled="!this.corregir"
                        @input="acceptNumberVolume"
                        @focus="focusUF($refs.volume)"
                        @blur="blurUF([$refs.volume, $refs.volumeInput.value])"
                        @keyup="volumeValidation()"
                        @keydown.tab="
                          collapseGrey([$refs.collapse, $refs.collapseMin])
                        "
                      />
                      <div
                        id="porcentaje-error"
                        class="errorlogin"
                        v-if="volumeIsValid === false"
                      >
                        Ingrese un volumen
                      </div>
                    </div>
                      <p style="text-align: justify;">
                        <b>
                          Ingresar volumen facturado año anterior en UF: este dato será corroborado por la Subgerencia de Contabilidad al revisar los antecedentes financieros de 
                          la empresa que se solicitan en el siguiente paso (Carpeta Tributaria Especial que emite el SII).                     
                        </b>
                      </p>
                      <p style="text-align: justify;">
                        <b>
                          En el caso que no coincida con lo informado por usted, le informaremos vía correo electrónico de la modificación realizada por la CChC, ya que este dato es utilizado para la fijación de cuotas básicas que se le asignan a cada socio al momento de ser aceptado por el Directorio.
                        </b>
                      </p>
                      <div class="md-checkbox">
                        <input
                          id="f1"
                          name="declaracion"
                          tabindex="31"
                          type="checkbox"
                          value="true"
                          v-model="declaracion"
                          @change="declaracionValidation()"
                          :disabled="!this.corregir"
                        />

                        <label for="f1">
                          <!-- <span class="label-input">Especialidades</span> -->
                          Conozco y acepto condiciones de postulación.
                        </label>
                        <div
                        id="declaracionst02-error"
                          class="errorDeclaracion"
                          v-if="declaracionIsValid === false"
                        >
                          Es obligatorio confirmar que has leído y aceptado las condiciones de postulación.
                        </div>
                      </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div
            class="c-form-drag greybg small font"
            ref="collapse"
            tabindex="6"
          >
            <div class="container">
              <a
                class="section-minimizar pointer"
                ref="collapseMin"
                @click="collapseClick([$refs.collapse, $refs.collapseMin])"
              >
                {{ collapse }}
              </a>
              <span
                tabindex="8"
                @keydown.tab="collapseGrey([$refs.collapse, $refs.collapseMin])"
              ></span>
              <div class="row">
                <div class="col-md-12 col-lg-6 offset-lg-2">
                  <div
                    id="loginrut-error"
                    class="errorFile"
                    v-if="dropzoneTwoIsValid === false"
                  >
                    Ingrese un archivo
                  </div>
                  <h2 tabindex="7">Antecendentes financieros de la empresa</h2>
                  <p>
                    A continuación ingrese los documentos que acreditan la
                    información de su empresa. <br /><br />
                    Carpeta Tributaria Especial que emite el SII. Esta contiene
                    información adicional relacionada a los IVA’s e Impuestos a
                    la Renta. Se deben seleccionar los siguientes contenidos:
                  </p>
                  <ul>
                    <!-- <li>Documento carpeta tributaria especial</li> -->
                    <!-- <li v-for="(docs, index) in tipoSocDocs[0]" :key="index">
                      {{docs}}
                    </li> -->
                    <li>Representante Legal</li>
                    <li>Conformación de la Sociedad</li>
                    <li>Participación de la Sociedad</li>
                    <li>Sucursales</li>
                    <li>Formulario 29 (12 meses)</li>
                    <li>Formulario 22 (2 años)</li>
                    <li>
                      "SE EXIMEN DE ESTOS ANTECEDENTES LAS FUNDACIONES Y
                      CORPORACIONES"
                    </li>
                  </ul>
                  <!-- <form class="dropzone dropzone-custom custom-drop" action="/file-upload" id="dz-form"></form> -->

                  <div
                    class="input"
                    tabindex="9"
                    @keydown.tab="
                      collapseOnceStepTwo([$refs.collapseC, $refs.collapseComp])
                    "
                  >
                    <vue-dropzone
                      v-if="this.corregir"
                      ref="myVueDropzone2"
                      :useCustomSlot="true"
                      id="dropzone2"
                      :duplicateCheck="true"
                      @vdropzone-upload-progress="uploadProgress"
                      :options="dropzoneOptions2"
                      @vdropzone-file-added="fileAdded2"
                      @vdropzone-sending-multiple="sendingFiles"
                      @vdropzone-success-multiple="success2"
                      @vdropzone-removed-file="removeFile2"
                      class="border2"
                    >
                      <div class="dropzone-custom-content svg">
                        <div class="subtitle"></div>
                      </div>
                    </vue-dropzone>
                  </div>

                  <br />
                  <!-- LISTA DE DOCUMENTOS RECPERADOS -->
                  <div>
                    <ul>
                      <li v-for="(doc, index) in files" v-bind:key="doc">
                        {{ doc }}
                        <button
                          class="link btn-red"
                          type="button"
                          @click="removeFileFromFiles(index)"
                          @keydown.tab="
                            collapseOnceStepTwo([
                              $refs.collapseC,
                              $refs.collapseComp,
                            ])
                          "
                        >
                          <strong> X </strong>
                        </button>
                      </li>
                    </ul>
                  </div>

                  <!-- <AttachmentList
                    :tempAttachments="getTempAttachments"
                    :attachments="getAttachments"
                  /> -->
                </div>
              </div>
            </div>
          </div>
          <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions2">
             <div class="dropzone-custom-content">
        <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
        <div class="subtitle">...or click to select a file from your computer</div>
      </div>
          </vue-dropzone> -->
          <div class="c-form-steps whitebg small" tabindex="10" ref="collapseC">
            <div class="container">
              <a
                class="section-minimizar pointer"
                ref="collapseComp"
                @click="collapseClick([$refs.collapseC, $refs.collapseComp])"
                data-formulario="4"
              >
                {{ collapse }}<span></span
              ></a>
              <div class="c-form-steps__content step-data u-pb0">
                <div class="row">
                  <div class="col-md-12 col-lg-6 offset-lg-2">
                    <form action="#" id="step04_3">
                      <h2 tabindex="11">COMPOSICIÓN ACCIONARIA</h2>

                      <div>
                        <input
                          type="checkbox"
                          id="c1"
                          class="chk-btn"
                          :disabled="this.companyPartner === true"
                          @click="selectPartner(1, true)"
                          v-model="companyPartner"
                        />
                        <label for="c1" class="checkboxButton">
                          Accionista Empresa
                        </label>
                        <input
                          type="checkbox"
                          id="c2"
                          class="chk-btn"
                          :disabled="this.personPartner === true"
                          @click="selectPartner(2)"
                          v-model="personPartner"
                        />
                        <label for="c2">
                          Accionista Persona
                        </label>

                        <!-- First position Company Partner -->
                        <div
                          v-if="this.companyPartner === true"
                          class="partner"
                        >
                          <div class="input" ref="firstRut">
                            <label
                              >RUT Persona Jurídica<i>
                                (<i class="contador">1</i> de
                                <i class="total">{{
                                  this.partnersArray.length + 1
                                }}</i
                                >)</i
                              ></label
                            >
                            <input
                              type="text"
                              name="rutCompany01"
                              tabindex="12"
                              v-model="firstPartnerArray[0].companyRut"
                              ref="rutPersonRefC"
                              @focus="focusPartner($refs.firstRut)"
                              @blur="
                                blurPartner([
                                  $refs.firstRut,
                                  firstPartnerArray[0].companyRut,
                                ]),
                                  rutIsValidCompanyValidation(
                                    $refs.rutPersonRefC.value,
                                    firstPartnerArray[0].companyRut
                                  ),
                                  findPostulanteExist(
                                    $refs.rutPersonRefC.value,
                                    0
                                  ),
                                  ValidationAccionista(
                                    $refs.rutPersonRefC.value,
                                    0
                                  ),
                                  rutDuplicates($refs.rutPersonRefC.value, 1, 0)
                              "
                              @keydown.space="(event) => event.preventDefault()"
                            />
                            <div class="small-text">
                              Sin puntos y con guión (11111111-1)
                            </div>

                            <div
                              id="giro_st03-error"
                              class="errorlogin"
                              v-if="companyRutIsValidArray[0] === false"
                            >
                              Ingrese un rut válido
                            </div>
                          </div>

                          <div class="input" ref="firstName">
                            <label
                              >Nombre o Razón Social<i>
                                (<i class="contador">1</i> de
                                <i class="total">{{
                                  partnersArray.length + 1
                                }}</i
                                >)</i
                              >
                            </label>
                            <input
                              type="text"
                              name="nombreCompany01"
                              v-model.trim="firstPartnerArray[0].businessName"
                              tabindex="12"
                              ref="nameInputC"
                              maxlength="100"
                              @focus="focusPartner($refs.firstName)"
                              @blur="
                                blurPartner([
                                  $refs.firstName,
                                  firstPartnerArray[0].businessName,
                                ])
                              "
                              @keyup="
                                businesNameValidation(
                                  firstPartnerArray[0].businessName,
                                  0
                                )
                              "
                              @keydown.space="preventLeadingSpace"
                            />
                            <div
                              id="giro_st03-error"
                              class="errorlogin"
                              v-if="businessNameIsValidArray[0] === false"
                            >
                              Ingrese un nombre
                            </div>
                          </div>

                          <div
                            class="input item-content u-mb70"
                            ref="firstSocietyPercentage"
                          >
                            <label
                              >Porcentaje de la sociedad<i>
                                (<i class="contador">1</i> de
                                <i class="total">{{
                                  partnersArray.length + 1
                                }}</i
                                >)</i
                              >
                            </label>
                            <input
                              type="number"
                              name="porcentajeCompany01"
                              v-model.trim="
                                firstPartnerArray[0].societyPercentageCompany
                              "
                              tabindex="12"
                              min="1"
                              max="100"
                              ref="societyPercentageInputC"
                              @input="acceptNumberPercentage"
                              @focus="
                                focusPartner($refs.firstSocietyPercentage)
                              "
                              @blur="
                                blurPartner([
                                  $refs.firstSocietyPercentage,
                                  firstPartnerArray[0].societyPercentageCompany,
                                ]),
                                  percentageValidation(
                                    firstPartnerArray[0]
                                      .societyPercentageCompany,
                                    0
                                  ),
                                  societyValidationCompany(
                                    firstPartnerArray[0]
                                      .societyPercentageCompany,
                                    0
                                  )
                              "
                              @keydown.space="preventLeadingSpace"
                            />
                            <div
                              id="giro_st03-error"
                              class="errorlogin"
                              v-if="
                                societyPercentageCompanyIsValidArray[0] ===
                                  false
                              "
                            >
                              Ingrese un porcentaje
                            </div>
                          </div>
                        </div>

                        <!-- First position Person Partner -->
                        <div v-if="this.personPartner === true" class="partner">
                          <div class="input" ref="secondRut">
                            <label
                              >RUT Persona Natural<i>
                                (<i class="contador">1</i> de
                                <i class="total">{{
                                  partnersArray.length + 1
                                }}</i
                                >)</i
                              ></label
                            >
                            <input
                              type="text"
                              name="rutpersona_st04"
                              tabindex="12"
                              v-model="firstPartnerArray[0].rutPerson"
                              ref="rutPersonRefP"
                              @focus="focus($refs.secondRut)"
                              @blur="
                                blur([
                                  $refs.secondRut,
                                  firstPartnerArray[0].rutPerson,
                                ]),
                                  validateRutExist(
                                    $refs.rutPersonRefP,
                                    $refs.rutPersonRefP.value,
                                    0
                                  ),
                                  rutDuplicates(
                                    $refs.rutPersonRefP.value,
                                    2,
                                    0
                                  );
                                findPostulanteExist(
                                  $refs.rutPersonRefP.value,
                                  0
                                );
                                ValidationAccionista(
                                  $refs.rutPersonRefP.value,
                                  0
                                );
                              "
                              @keyup="
                                rutIsValidPersonValidation(
                                  $refs.rutPersonRefP.value,
                                  0
                                )
                              "
                              @keydown.space="(event) => event.preventDefault()"
                            />
                            <div class="small-text">
                              Sin puntos y con guión (11111111-1)
                            </div>

                            <div
                              id="giro_st03-error"
                              class="errorlogin"
                              v-if="rutPersonIsValidArray[0] === false"
                            >
                              Ingrese un rut válido
                            </div>
                          </div>

                          <div class="input" ref="secondName">
                            <label
                              >Nombre<i>
                                (<i class="contador">1</i> de
                                <i class="total">{{
                                  partnersArray.length + 1
                                }}</i
                                >)</i
                              >
                            </label>
                            <input
                              type="text"
                              name="nombrepersona_st04"
                              v-model.trim="firstPartnerArray[0].name"
                              tabindex="12"
                              ref="nameInputP"
                              maxlength="100"
                              @focus="focus($refs.secondName)"
                              @blur="
                                blur([
                                  $refs.secondName,
                                  firstPartnerArray[0].name,
                                ])
                              "
                              @keyup="
                                nameValidation(firstPartnerArray[0].name, 0)
                              "
                              @keydown.space="preventLeadingSpace"
                            />
                            <div
                              id="giro_st03-error"
                              class="errorlogin"
                              v-if="nameIsValidArray[0] === false"
                            >
                              Ingrese un nombre
                            </div>
                          </div>

                          <div class="input" ref="secondLastname">
                            <label
                              >Apellido Paterno<i>
                                (<i class="contador">1</i> de
                                <i class="total">{{
                                  partnersArray.length + 1
                                }}</i
                                >)</i
                              >
                            </label>
                            <input
                              type="text"
                              name="apellido1persona_st04"
                              v-model.trim="firstPartnerArray[0].fatherLastname"
                              tabindex="12"
                              maxlength="100"
                              ref="fatherLastnameInputP"
                              @focus="focus($refs.secondLastname)"
                              @blur="
                                blur([
                                  $refs.secondLastname,
                                  firstPartnerArray[0].fatherLastname,
                                ])
                              "
                              @keyup="
                                fatherLastnameValidation(
                                  firstPartnerArray[0].fatherLastname,
                                  0
                                )
                              "
                              @keydown.space="preventLeadingSpace"
                            />
                            <div
                              id="giro_st03-error"
                              class="errorlogin"
                              v-if="fatherLastnameIsValidArray[0] === false"
                            >
                              Ingrese un apellido
                            </div>
                          </div>
                          <div class="input" ref="secondMotherLastname">
                            <label
                              >Apellido Materno<i>
                                (<i class="contador">1</i> de
                                <i class="total">{{
                                  partnersArray.length + 1
                                }}</i
                                >)</i
                              >
                            </label>
                            <!-- {{this.partners.length}} --
                            {{this.inputsPartner[1]}} --
                            {{this.counter}} -->
                            <input
                              type="text"
                              name="apellido2persona_st04"
                              v-model.trim="firstPartnerArray[0].motherLastname"
                              tabindex="12"
                              ref="motherLastnameInputP"
                              maxlength="100"
                              @focus="focus($refs.secondMotherLastname)"
                              @blur="
                                blur([
                                  $refs.secondMotherLastname,
                                  $refs.motherLastnameInputP.value,
                                ])
                              "
                              @keyup="
                                motherLastnameValidation(
                                  firstPartnerArray[0].motherLastname,
                                  0
                                )
                              "
                              @keydown.space="preventLeadingSpace"
                            />
                            <div
                              id="giro_st03-error"
                              class="errorlogin"
                              v-if="motherLastnameIsValidArray[0] === false"
                            >
                              Ingrese un apellido
                            </div>
                          </div>

                          <div class="input" ref="secondSocietyPercentage">
                            <label
                              >Porcentaje de la sociedad<i>
                                (<i class="contador">1</i> de
                                <i class="total">{{
                                  partnersArray.length + 1
                                }}</i
                                >)</i
                              >
                            </label>
                            <input
                              type="number"
                              name="porcentajesociedad_st04"
                              v-model.trim="
                                firstPartnerArray[0].societyPercentagePerson
                              "
                              tabindex="12"
                              ref="societyPercentageInputP"
                              @input="acceptNumberPercentage"
                              @focus="focus($refs.secondSocietyPercentage)"
                              @blur="
                                blur([
                                  $refs.secondSocietyPercentage,
                                  $refs.societyPercentageInputP.value,
                                ]),
                                  percentageValidation(
                                    $refs.societyPercentageInputP.value,
                                    0
                                  )
                              "
                              @keyup="
                                societyValidationPerson(
                                  firstPartnerArray[0].societyPercentagePerson,
                                  0
                                )
                              "
                              @keydown.space="preventLeadingSpace"
                            />
                            <div
                              id="giro_st03-error"
                              class="errorlogin"
                              v-if="
                                societyPercentagePersonIsValidArray[0] === false
                              "
                            >
                              Ingrese un porcentaje
                            </div>
                          </div>
                        </div>

                        <div
                          class="content-repeater"
                          id="repeater"
                          v-if="partnersArray.length > 0"
                        >
                          <div
                            class="wrapper-repeater"
                            v-for="(partner, index) in partnersArray"
                            :key="index"
                          >
                            <div>
                              <input
                                type="checkbox"
                                :id="'c' + parseInt(index) + parseInt(3)"
                                class="chk-btn"
                                v-model="partner.company"
                                :disabled="partner.company === true"
                                @click="selectPartnerInArray(1, index)"
                              />
                              <label
                                :for="'c' + parseInt(index) + parseInt(3)"
                                class="checkboxButton"
                              >
                                Accionista Empresa
                              </label>
                              <input
                                type="checkbox"
                                :id="index + 4"
                                class="chk-btn"
                                v-model="partner.person"
                                :disabled="partner.person === true"
                                @click="selectPartnerInArray(2, index)"
                              />
                              <label :for="index + 4">
                                Accionista Persona
                              </label>

                              <!-- First position Company Partner -->
                              <div
                                v-if="partner.company === true"
                                class="partner"
                              >
                                <div
                                  class="input item-content u-mb70"
                                  ref="rut"
                                >
                                  <label
                                    >RUT Persona Jurídica<i>
                                      (<i class="contador">{{ index + 2 }}</i>
                                      de
                                      <i class="total">{{
                                        partnersArray.length + 1
                                      }}</i
                                      >)</i
                                    ></label
                                  >
                                  <input
                                    type="text"
                                    name="rutpersona_st04"
                                    tabindex="12"
                                    v-model="partner.companyRut"
                                    ref="rutPersonRef"
                                    @focus="focusPartner($refs.rut[index])"
                                    @blur="
                                      blurPartner([
                                        $refs.rut[index],
                                        partner.companyRut,
                                      ]),
                                        findPostulanteExist(
                                          $refs.rutPersonRef[index].value,
                                          index + 1
                                        ),
                                        rutIsValidCompanyValidation(
                                          $refs.rutPersonRef[index].value,
                                          index + 1
                                        ),
                                        rutDuplicates(
                                          $refs.rutPersonRef[index].value,
                                          1,
                                          index + 1
                                        )
                                    "
                                    @keydown.space="
                                      (event) => event.preventDefault()
                                    "
                                  />
                                  <div class="small-text">
                                    Sin puntos y con guión (11111111-1)
                                  </div>

                                  <div
                                    id="giro_st03-error"
                                    class="errorlogin"
                                    v-if="
                                      companyRutIsValidArray[index + 1] ===
                                        false
                                    "
                                  >
                                    Ingrese un rut válido
                                  </div>
                                </div>

                                <div
                                  class="input item-content u-mb70"
                                  ref="name"
                                >
                                  <label
                                    >Nombre o Razón Social<i>
                                      (<i class="contador">{{ index + 2 }}</i>
                                      de
                                      <i class="total">{{
                                        partnersArray.length + 1
                                      }}</i
                                      >)</i
                                    >
                                  </label>
                                  <input
                                    type="text"
                                    name="nombrepersona_st04"
                                    v-model.trim="partner.businessName"
                                    tabindex="12"
                                    ref="nameInput"
                                    maxlength="100"
                                    @focus="focusPartner($refs.name[index])"
                                    @blur="
                                      blurPartner([
                                        $refs.name[index],
                                        partner.businessName,
                                      ]),
                                        businesNameValidation(
                                          partner.businessName,
                                          index + 1
                                        )
                                    "
                                    @keydown.space="preventLeadingSpace"
                                  />
                                  <div
                                    id="giro_st03-error"
                                    class="errorlogin"
                                    v-if="
                                      businessNameIsValidArray[index + 1] ===
                                        false
                                    "
                                  >
                                    Ingrese un nombre
                                  </div>
                                </div>

                                <!-- <div class="input item-content u-mb70" ref="societyPercentage"> -->
                                <div
                                  class="input item-content"
                                  ref="societyPercentage"
                                >
                                  <label
                                    >Porcentaje de la sociedad<i>
                                      (<i class="contador">{{ index + 2 }}</i>
                                      de
                                      <i class="total">{{
                                        partnersArray.length + 1
                                      }}</i
                                      >)</i
                                    >
                                  </label>
                                  <input
                                    type="number"
                                    name="porcentajesociedad_st04"
                                    v-model="partner.societyPercentageCompany"
                                    tabindex="12"
                                    ref="societyPercentageInput"
                                    @input="acceptNumberPercentage"
                                    @focus="
                                      focusPartner(
                                        $refs.societyPercentage[index]
                                      )
                                    "
                                    @blur="
                                      blurPartner([
                                        $refs.societyPercentage[index],
                                        partner.societyPercentageCompany,
                                      ]),
                                        percentageValidation(
                                          partner.societyPercentageCompany,
                                          index + 1
                                        ),
                                        societyValidationCompany(
                                          $refs.societyPercentageInput[index]
                                            .value,
                                          index + 1
                                        )
                                    "
                                    @keydown.space="preventLeadingSpace"
                                  />
                                  <div
                                    id="giro_st03-error"
                                    class="errorlogin"
                                    v-if="
                                      societyPercentageCompanyIsValidArray[
                                        index + 1
                                      ] === false
                                    "
                                  >
                                    Ingrese un porcentaje
                                  </div>
                                </div>

                                <div
                                  class="input item-content u-mb70"
                                  v-show="showCompanyInputs"
                                  ref="lastname"
                                >
                                  <label
                                    >Apellido Paterno<i>
                                      (<i class="contador">{{ index + 2 }}</i>
                                      de
                                      <i class="total">{{
                                        partnersArray.length + 1
                                      }}</i
                                      >)</i
                                    >
                                  </label>
                                  <input
                                    type="text"
                                    name="apellido1persona_st04"
                                    v-model="partner.fatherLastname"
                                    tabindex="14"
                                    maxlength="100"
                                    ref="fatherLastnameInput"
                                    @focus="focus($refs.lastname[index])"
                                    @blur="
                                      blur([
                                        $refs.lastname[index],
                                        partner.fatherLastname,
                                      ]),
                                        fatherLastnameValidation(
                                          partner.fatherLastname,
                                          index + 1
                                        )
                                    "
                                  />
                                  <div
                                    id="giro_st03-error"
                                    class="errorlogin"
                                    v-if="
                                      fatherLastnameIsValidArray[index + 1] ===
                                        false
                                    "
                                  >
                                    Ingrese un apellido
                                  </div>
                                </div>
                                <div
                                  class="input item-content u-mb70"
                                  v-show="showPersonInputs"
                                  ref="motherLastname"
                                >
                                  <label
                                    >Apellido Materno<i>
                                      (<i class="contador">{{ index + 2 }}</i>
                                      de
                                      <i class="total">{{
                                        partnersArray.length + 1
                                      }}</i
                                      >)</i
                                    >
                                  </label>
                                  <input
                                    type="text"
                                    name="apellido2persona_st04"
                                    v-model="partner.motherLastname"
                                    tabindex="15"
                                    ref="motherLastnameInput"
                                    maxlength="100"
                                    @focus="focus($refs.motherLastname[index])"
                                    @blur="
                                      blur([
                                        $refs.motherLastname[index],
                                        $refs.motherLastnameInput[index].value,
                                      ]),
                                        motherLastnameValidation(
                                          $refs.motherLastnameInput[index]
                                            .value,
                                          index + 1
                                        )
                                    "
                                  />
                                  <div
                                    id="giro_st03-error"
                                    class="errorlogin"
                                    v-if="
                                      motherLastnameIsValidArray[index + 1] ===
                                        false
                                    "
                                  >
                                    Ingrese un apellido
                                  </div>
                                </div>
                              </div>

                              <!-- First position Person Partner -->
                              <div
                                v-if="partner.person === true"
                                class="partner"
                              >
                                <div
                                  class="input item-content u-mb70"
                                  ref="rut"
                                >
                                  <label
                                    >RUT Persona Natural<i>
                                      (<i class="contador">{{ index + 2 }}</i>
                                      de
                                      <i class="total">{{
                                        partnersArray.length + 1
                                      }}</i
                                      >)</i
                                    ></label
                                  >
                                  <input
                                    type="text"
                                    name="rutpersona_st04"
                                    tabindex="12"
                                    v-model="partner.rutPerson"
                                    ref="rutPersonRef"
                                    @focus="focus($refs.rut[index])"
                                    @blur="
                                      blur([
                                        $refs.rut[index],
                                        partner.rutPerson,
                                      ]),
                                        validateRutExist(
                                          $refs.rutPersonRef[index],
                                          partner.rutPerson,
                                          0
                                        ),
                                        rutIsValidPersonValidation(
                                          $refs.rutPersonRef[index].value,
                                          index + 1
                                        ),
                                        findPostulanteExist(
                                          $refs.rutPersonRef[index].value,
                                          index + 1
                                        ),
                                        rutDuplicates(
                                          $refs.rutPersonRef[index].value,
                                          2,
                                          index + 1
                                        )
                                    "
                                    @keydown.space="
                                      (event) => event.preventDefault()
                                    "
                                  />
                                  <div class="small-text">
                                    Sin puntos y con guión (11111111-1)
                                  </div>

                                  <div
                                    id="giro_st03-error"
                                    class="errorlogin"
                                    v-if="
                                      rutPersonIsValidArray[index + 1] === false
                                    "
                                  >
                                    Ingrese un rut válido
                                  </div>
                                </div>

                                <div
                                  class="input item-content u-mb70"
                                  ref="name"
                                >
                                  <label
                                    >Nombre<i>
                                      (<i class="contador">{{ index + 2 }}</i>
                                      de
                                      <i class="total">{{
                                        partnersArray.length + 1
                                      }}</i
                                      >)</i
                                    >
                                  </label>
                                  <input
                                    type="text"
                                    name="nombrepersona_st04"
                                    v-model.trim="partner.name"
                                    tabindex="12"
                                    ref="nameInput"
                                    maxlength="100"
                                    @focus="focus($refs.name[index])"
                                    @blur="
                                      blur([$refs.name[index], partner.name]),
                                        nameValidation(partner.name, index + 1)
                                    "
                                    @keydown.space="preventLeadingSpace"
                                  />
                                  <div
                                    id="giro_st03-error"
                                    class="errorlogin"
                                    v-if="nameIsValidArray[index + 1] === false"
                                  >
                                    Ingrese un nombre
                                  </div>
                                </div>

                                <div
                                  class="input item-content u-mb70"
                                  ref="lastname"
                                >
                                  <label
                                    >Apellido Paterno<i>
                                      (<i class="contador">{{ index + 2 }}</i>
                                      de
                                      <i class="total">{{
                                        partnersArray.length + 1
                                      }}</i
                                      >)</i
                                    >
                                  </label>
                                  <input
                                    type="text"
                                    name="apellido1persona_st04"
                                    v-model.trim="partner.fatherLastname"
                                    tabindex="12"
                                    maxlength="100"
                                    ref="fatherLastnameInput"
                                    @focus="focus($refs.lastname[index])"
                                    @blur="
                                      blur([
                                        $refs.lastname[index],
                                        partner.fatherLastname,
                                      ]),
                                        fatherLastnameValidation(
                                          partner.fatherLastname,
                                          index + 1
                                        )
                                    "
                                    @keydown.space="preventLeadingSpace"
                                  />
                                  <div
                                    id="giro_st03-error"
                                    class="errorlogin"
                                    v-if="
                                      fatherLastnameIsValidArray[index + 1] ===
                                        false
                                    "
                                  >
                                    Ingrese un apellido
                                  </div>
                                </div>
                                <div
                                  class="input item-content u-mb70"
                                  ref="motherLastname"
                                >
                                  <label
                                    >Apellido Materno<i>
                                      (<i class="contador">{{ index + 2 }}</i>
                                      de
                                      <i class="total">{{
                                        partnersArray.length + 1
                                      }}</i
                                      >)</i
                                    >
                                  </label>
                                  <input
                                    type="text"
                                    name="apellido2persona_st04"
                                    v-model.trim="partner.motherLastname"
                                    tabindex="12"
                                    ref="motherLastnameInput"
                                    maxlength="100"
                                    @focus="focus($refs.motherLastname[index])"
                                    @blur="
                                      blur([
                                        $refs.motherLastname[index],
                                        $refs.motherLastnameInput[index].value,
                                      ]),
                                        motherLastnameValidation(
                                          partner.motherLastname,
                                          index + 1
                                        )
                                    "
                                    @keydown.space="preventLeadingSpace"
                                  />
                                  <div
                                    id="giro_st03-error"
                                    class="errorlogin"
                                    v-if="
                                      motherLastnameIsValidArray[index + 1] ===
                                        false
                                    "
                                  >
                                    Ingrese un apellido
                                  </div>
                                </div>

                                <!--  <div class="input item-content u-mb70" ref="societyPercentage"> -->
                                <div
                                  class="input item-content"
                                  ref="societyPercentage"
                                >
                                  <label
                                    >Porcentaje de la sociedad<i>
                                      (<i class="contador">{{ index + 2 }}</i>
                                      de
                                      <i class="total">{{
                                        partnersArray.length + 1
                                      }}</i
                                      >)</i
                                    >
                                  </label>
                                  <input
                                    type="number"
                                    name="porcentajesociedad_st04"
                                    v-model="partner.societyPercentagePerson"
                                    tabindex="12"
                                    ref="societyPercentageInput"
                                    @input="acceptNumberPercentage"
                                    @focus="
                                      focus($refs.societyPercentage[index])
                                    "
                                    @blur="
                                      blur([
                                        $refs.societyPercentage[index],
                                        $refs.societyPercentageInput[index]
                                          .value,
                                      ]),
                                        percentageValidation(
                                          $refs.societyPercentageInput[index]
                                            .value,
                                          index + 1
                                        ),
                                        societyValidationPerson(
                                          $refs.societyPercentageInput[index]
                                            .value,
                                          index + 1
                                        )
                                    "
                                    @keydown.space="preventLeadingSpace"
                                  />
                                  <div
                                    id="giro_st03-error"
                                    class="errorlogin"
                                    v-if="
                                      societyPercentagePersonIsValidArray[
                                        index + 1
                                      ] === false
                                    "
                                  >
                                    Ingrese un porcentaje
                                  </div>
                                </div>
                              </div>
                            </div>

                            <button
                              class="link prev btn-red u-mt20 u-mr30 small"
                              type="button"
                              @click="deletePartner(index)"
                            >
                              Eliminar socio
                            </button>

                            <hr />
                          </div>
                        </div>

                        <a
                          class="input-repeater pointer"
                          v-if="companyPartner == true || personPartner == true"
                          @click="addPartner()"
                          >Añadir otro socio<span>+</span>
                        </a>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="c-form-steps whitebg">
            <div class="container">
              <div class="c-form-steps__content step-data">
                <div class="row">
                  <div class="col-md-12 col-lg-12 offset-lg-2">
                    <form id="step04_3">
                      <button
                        class="link prev btn-blue u-mt50 u-mr30 small"
                        type="button"
                        @click="goStepOne(), scrollToTop()"
                      >
                        <i class="fa fa-angle-left"></i>Anterior
                      </button>
                      <div
                        v-if="!this.tieneCorreccion"
                        style="display: inline;"
                      >
                        <button
                          class="link btn-red u-mt50 big u-mr20"
                          type="button"
                          tabindex="17"
                          @click="saveSteptwo()"
                        >
                          Guardar<i class="fa fa-angle-right"></i>
                        </button>
                      </div>
                      <button
                        class="link btn-red u-mt50 big"
                        type="button"
                        tabindex="18"
                        @click="checkFormStepTwo(), scrollToTop()"
                        v-if="formLoaded == true"
                      >
                        Continuar<i class="fa fa-angle-right"></i>
                      </button>
                      <button
                        class="link btn-red u-mt50 big"
                        tabindex="24"
                        id="submitStep04"
                        type="button"
                        :disabled="!formLoaded"
                        v-if="formLoaded == false"
                      >
                        Continuar<i class="fa fa-angle-right"></i>
                      </button>
                      <!-- {{completedForm}} <br> -->
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Cabecera from "@/components/Cabecera.vue";
import StepNumbers from "../../components/StepNumbers.vue";
//Store import
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
//Vue Dropzone
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import axios from "axios";
import VueAxios from "vue-axios";

import mixin from "@/mixins/mixin.js";

import Swal from "sweetalert2";

import numeral from "numeral";

import { normalizeText } from "normalize-text";

export default {
  name: "StepTwo",
  mixins: [mixin],
  components: {
    Cabecera,
    StepNumbers,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      formLoaded: false,
      urlBase: this.$store.state.URL,
      firstPercentage: "",
      rutParticipante: "",
      secondPercentage: "",
      rut: "",
      volume: "",
      postulanteExistente: [],
      entidadCchc: [],
      //rutPerson: '',
      //name: '',
      //fatherLastname: '',
      //motherLastname: '',
      //societyPercentage: '',
      wasFilesChanged: false,
      inputsPartner: [
        {
          rutPerson: "",
          name: "",
          fatherLastname: "",
          motherLastname: "",
          societyPercentage: "",
        },
      ],
      partners: [],
      lengthPartners: "",
      sumPartners: 0,
      total: 0,
      totalPercentage: 0,
      totalEmployeesIsValid: "",
      rangeIsValid: "",
      firstPercentageIsValid: "",
      secondPercentageIsValid: "",
      volumeIsValid: "",
      dropzoneTwoIsValid: "",
      companyRutIsValidArray: [],
      rutPersonIsValidArray: [],
      nameIsValid: "",
      nameIsValidArray: [],
      businessNameIsValidArray: [],
      fatherLastnameIsValid: "",
      fatherLastnameIsValidArray: [],
      motherLastnameIsValid: "",
      motherLastnameIsValidArray: [],
      societyPercentageIsValid: true,
      societyPercentageInputIsValid: "",
      societyPercentageCompanyIsValidArray: [],
      societyPercentagePersonIsValidArray: [],
      postulanteExistente: [],
      rutCheck: [],
      formIsValid: "",
      noZeroPercentage: false,

      tempAttachments: [],
      attachments: [],
      dropzoneOptions2: {
        // The Url Where Dropped or Selected files will be sent
        url: `https://httpbin.org/post`,
        // File Size allowed in MB
        maxFilesize: 10,
        // Authentication Headers like Access_Token of your application
        headers: {
          Authorization: `Access Token`,
        },
        // The way you want to receive the files in the server
        paramName: function(n) {
          return "file[]";
        },
        //dictDefaultMessage: "Upload Files Here xD",
        //includeStyling: false,
        //previewsContainer: false,
        autoProcessQueue : false,
        thumbnailWidth: 250,
        thumbnailHeight: 140,
        uploadMultiple: true,
        parallelUploads: 20,
        addRemoveLinks: true,
        dictRemoveFile: "Eliminar archivo",
        dictCancelUpload: "Cancelar subida",
        dictInvalidFileType: "No puede subir archivos con este formato.",
        dictFileTooBig:
          "El archivo es muy grande ({{filesize}}MB). Máximo: {{maxFilesize}}MB.",
        acceptedFiles: ".jpg, .jpeg, .xls, .xlsx, .pdf, .doc, .docx, .png",
        dictCancelUploadConfirmation:
          "¿Está seguro que desea cancelar esta subida?",
      },

      stepTwoObject: [],
      files: [],
      filesStepTwo:[],
      objectData: {},
      getStepTwo: [],
      storeObjectStepTwo: [],
      composicionAccionaria: [],
      banderaActivarClases: false,
      corregir: true,
      tieneCorreccion: false,
      counter: 0,
      //PARTNERS NEW METHOD (ACCIONISTAS)
      companyPartner: false,
      personPartner: false,
      showCompanyInputs: false,
      showPersonInputs: false,
      showPersonPartner: false,
      partnerCounter: 0,
      partnerCounter2: 0,
      partnersArray: [],
      radio: false,
      radio2: false,
      firstPartnerArray: [
        {
          company: "",
          person: "",
          companyRut: "",
          rutPerson: "",
          businessName: "",
          name: "",
          fatherLastname: "",
          motherLastname: "",
          societyPercentageCompany: "",
          societyPercentagePerson: "",
        },
      ],
      checkInputs: [],
      percentageTotal: [],
      duplicates: "",
      rec_activated: false,
      limit: "",
      declaracion: false,
      declaracionIsValid: "",
    };
  },

  methods: {
    ...mapGetters([
      "getterTotalEmployees",
      "getterRange",
      "getterRutIsValid",
      "getterObjectData",
      "getterObjetoStepTwo",
    ]),
    ...mapMutations([
      "focus",
      "blur",
      "rutValidation",
      "collapseClick",
      "collapseGrey",
      "collapseTab2",
      "collapseOnceStepTwo",
      "setVueDropzoneFile",
      "setTotalEmployees",
      "setRange",
      "setRutIsValid",
      "setStepOneValue",
      "setStepTwoValue",
      "setStepThreeValue",
      "saveCompletedForm",
      "getRutParnersGlobal",
      "getRutParnerGlobal",
      "setVueDropzoneFileTwo",
      "focusPercentage",
      "focusPartner",
      "blurPercentage",
      "blurPartner",
      "focusUF",
      "blurUF",
      "setObjetoStepTwo",
      "setFormatedName",
    ]),

    ...mapActions([
      "companyBackgroundUploadTwo",
      "getTotalEmployees",
      "getRange",
    ]),

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    selectPartner(partner, test) {
      //console.log(partner);
      //console.log(test);
      //console.log(this.partnersArray.length);
      if (partner === 1) {
        this.personPartner = false;
        this.companyPartner = true;
        //console.log("companyPartner: " + this.companyPartner);
        this.firstPartnerArray[0].company = true;
        //console.log(this.partnersArray);
        //console.log(this.firstPartnerArray);
        this.firstPartnerArray[0].person = "";
        this.firstPartnerArray[0].rutPerson = "";
        this.firstPartnerArray[0].name = "";
        this.firstPartnerArray[0].fatherLastname = "";
        this.firstPartnerArray[0].motherLastname = "";
        this.firstPartnerArray[0].societyPercentagePerson = "";
        this.rutPersonIsValidArray[0] = "";
        this.nameIsValidArray[0] = "";
        this.fatherLastnameIsValidArray[0] = "";
        this.motherLastnameIsValidArray[0] = "";
        this.societyPercentagePersonIsValidArray[0] = "";
        this.percentageValidation(1, 0);

        //console.log(this.rutPersonIsValidArray.length);
      }
      if (partner === 2) {
        //console.log(this.personPartner);
        //console.log(this.$refs.firstRut);

        this.personPartner = true;
        this.companyPartner = false;
        this.firstPartnerArray[0].person = true;
        //console.log(this.partnersArray);
        //console.log(this.firstPartnerArray);
        this.firstPartnerArray[0].company = "";
        this.firstPartnerArray[0].companyRut = "";
        this.firstPartnerArray[0].businessName = "";
        this.firstPartnerArray[0].societyPercentageCompany = "";
        this.companyRutIsValidArray[0] = "";
        this.businessNameIsValidArray[0] = "";
        this.societyPercentageCompanyIsValidArray[0] = "";
        this.percentageValidation(1, 0);
        //this.$refs.firstRut.className = 'input item-content u-mb70'
      }
    },

    selectPartnerInArray(value, index) {
      //console.log(value);
      //console.log(index);

      if (value === 1) {
        this.partnersArray[index].person = "";
        this.partnersArray[index].rutPerson = "";
        this.partnersArray[index].name = "";
        this.partnersArray[index].fatherLastname = "";
        this.partnersArray[index].motherLastname = "";
        this.partnersArray[index].societyPercentagePerson = "";
        this.rutPersonIsValidArray[index + 1] = "";
        this.nameIsValidArray[index + 1] = "";
        this.fatherLastnameIsValidArray[index + 1] = "";
        this.motherLastnameIsValidArray[index + 1] = "";
        this.societyPercentagePersonIsValidArray[index + 1] = "";
        this.percentageValidation(1, index + 1);
      }

      if (value === 2) {
        this.partnersArray[index].company = "";
        this.partnersArray[index].companyRut = "";
        this.partnersArray[index].businessName = "";
        this.partnersArray[index].societyPercentageCompany = "";
        this.companyRutIsValidArray[index + 1] = "";
        this.businessNameIsValidArray[index + 1] = "";
        this.societyPercentageCompanyIsValidArray[index + 1] = "";
        this.percentageValidation(1, index + 1);
      }
    },

    acceptNumber() {
      var regex = /(^\d{1,7})+(\,\d{0,2})?$/;
      if (!regex.test(this.firstPercentage)) {
        //this.firstPercentage = '';
        this.firstPercentageIsValid = false;
      }
    },

    acceptNumberSecond() {
      var x = this.secondPercentage
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.secondPercentage = !x[2] ? x[1] : x[1] + x[2] + (x[3] ? +x[3] : "");
    },
    acceptNumberVolume() {
      var x = this.volume
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.volume = !x[2] ? x[1] : x[1] + x[2] + (x[3] ? +x[3] : "");
    },
    declaracionValidation() {
      if (this.declaracion) {
        this.declaracionIsValid = true;
      } else {
        this.declaracionIsValid = false;
      }
    },

    acceptNumberPercentage() {
      /*var x = this.inputsPartner[0].societyPercentage.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.inputsPartner[0].societyPercentage = !x[2] ? x[1] :  x[1] + x[2] + (x[3] ? + x[3] : '');*/

      Number.isFloat =
        Number.isFloat ||
        function(value) {
          return (
            typeof value === "number" &&
            isFinite(value) &&
            Math.floor(value) !== value
          );
        };
    },

    employeesTotalValidation() {
      if (this.selectedTotalEmployees == "") {
        this.totalEmployeesIsValid = false;
      } else {
        this.totalEmployeesIsValid = true;
      }
    },

    rangeValidation() {
      if (this.selectedRange == "") {
        this.rangeIsValid = false;
      } else {
        this.rangeIsValid = true;
      }
    },

    doOtherStuff() {
      var test = numeral(1234567.567).format("0.[00]");
      // '1,000'

      //console.log(test);
    },

    firstPercentageValidation(input) {
      //let success;
      var regex = /(^[0-9]{1,7}$|^[0-9]{1,7}\,[0-9]{1,2}$)/;
      let regexInteger = /^\d{7}$/;
      /*if (!regexInteger.test(this.firstPercentage)) {
          this.firstPercentageIsValid = false;
          this.limit = 7;
        } else {
          this.firstPercentageIsValid = true;
        }*/

      if (!regex.test(this.firstPercentage) || this.firstPercentage == "") {
        this.firstPercentageIsValid = false;
        //this.doOtherStuff();
      } else {
        this.firstPercentageIsValid = true;
        //this.limit = ''
      }
    },

    secondPercentageValidation() {
      if (this.secondPercentage == "") {
        this.secondPercentageIsValid = false;
      } else {
        this.secondPercentageIsValid = true;
      }

      if (this.secondPercentage > 100) {
        this.secondPercentageIsValid = false;
        Swal.fire({
          icon: "warning",
          title: "El porcentaje no debe ser mayor a 100.",
          //text: 'El máximo de caracteres es 100.',
          //footer: '<a href>Why do I have this issue?</a>'
        });
      }
      if (this.secondPercentage == 0) {
        this.secondPercentageIsValid = false;
        Swal.fire({
          icon: "warning",
          title: "El porcentaje debe ser mayor a 0.",
          //text: 'El máximo de caracteres es 100.',
          //footer: '<a href>Why do I have this issue?</a>'
        });
      }
    },

    percentageValidationTest(percentage) {
      let isPercentage = /^(100|[0-9]{1,2}|\d{1,2}[.]\d{1,2})$/.test(
        percentage
      );
      return isPercentage;
    },

    volumeValidation() {
      if (this.volume == "") {
        this.volumeIsValid = false;
      } else {
        this.volumeIsValid = true;
      }
    },

    preventLeadingSpace(e) {
      // only prevent the keypress if the value is blank
      if (!e.target.value) e.preventDefault();
      // otherwise, if the leading character is a space, remove all leading white-space
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },

    rutDuplicates(rut, type, index) {
      //console.log(rut);
      //console.log(type);
      //console.log(index);
      let rutCheck = [];
      let rutAux;

      /*if (this.rutIsValid !== false) {

          if (this.firstPartnerArray[index].companyRut !== '') {
            rutCheck.splice(index, 1, rut);
            //console.log("company");
            //console.log(index);

          } else if (this.firstPartnerArray[index].rutPerson !== '') {
            rutCheck.splice(index, 1, rut);
            //console.log("person");
            //console.log(index);
          }

          //console.log(rutCheck);
        }*/

      this.firstPartnerArray.forEach(function(value, index, array) {
        //console.log("En el índice " + index + " hay este valor: " + JSON.stringify(value));
        //console.log(array[index]);
        if (value.companyRut !== "") {
          rutCheck.push(value.companyRut);
        } else if (value.rutPerson !== "") {
          rutCheck.push(value.rutPerson);
        }
        //console.log(rutCheck);
      });

      const tempArray = [...rutCheck].sort();
      let duplicados = [];
      for (let i = 0; i < tempArray.length; i++) {
        if (tempArray[i + 1] === tempArray[i]) {
          duplicados.push(tempArray[i]);
        }
      }
      //console.log(duplicados);
      ////console.log(rutCheck);

      if (duplicados.length > 0) {
        for (let i = 0; i < duplicados.length; i++) {
          //console.log(duplicados[i]);
          Swal.fire({
            icon: "error",
            title: "¡ERROR!",
            text: "El RUT " + duplicados[i] + " está duplicado.",
            //footer: '<a href>Why do I have this issue?</a>'
          });
        }
        this.duplicates = false;
      } else {
        this.duplicates = true;
      }
    },

    rutIsValidCompanyValidation(rut, index) {
      //console.log(rut);
      //console.log(index);
      this.rutValidation(rut);
      if (this.rutIsValid === false || rut === "") {
        this.companyRutIsValidArray.splice(index, 1, false);
        //console.log(this.companyRutIsValidArray[index]);
      } else if (this.rutIsValid === true) {
        this.companyRutIsValidArray.splice(index, 1, true);
      }
      //console.log(this.companyRutIsValidArray.length);
    },

    rutIsValidPersonValidation(rut, index) {
      //console.log(rut);
      //console.log(index);
      this.rutValidation(rut);
      //console.log(this.rutIsValid);
      if (this.rutIsValid === false || rut === "") {
        this.rutPersonIsValidArray.splice(index, 1, false);
        //console.log(this.rutPersonIsValidArray[index]);
      } else if (this.rutIsValid === true) {
        this.rutPersonIsValidArray.splice(index, 1, true);
      }
      //console.log(this.rutPersonIsValidArray.length);
    },

    nameValidation(name, index) {
      //console.log(name);
      //console.log(index);
      if (name === "") {
        this.nameIsValidArray.splice(index, 1, false);
        //console.log(this.nameIsValidArray[index]);
      } else if (name !== "") {
        this.nameIsValidArray.splice(index, 1, true);
      }
      //console.log(this.nameIsValidArray.length);
    },

    businesNameValidation(name, index) {
      //console.log(name);
      //console.log(index);
      if (name === "") {
        this.businessNameIsValidArray.splice(index, 1, false);
        //console.log(this.businessNameIsValidArray[index]);
      } else if (name !== "") {
        this.businessNameIsValidArray.splice(index, 1, true);
      }
      //console.log(this.businessNameIsValidArray.length);
    },

    fatherLastnameValidation(fatherLastname, index) {
      //console.log(fatherLastname);
      //console.log(index);
      if (fatherLastname === "") {
        this.fatherLastnameIsValidArray.splice(index, 1, false);
        //console.log(this.fatherLastnameIsValidArray[index]);
      } else if (fatherLastname !== "") {
        this.fatherLastnameIsValidArray.splice(index, 1, true);
      }
      //console.log(this.fatherLastnameIsValidArray.length);
    },

    motherLastnameValidation(motherLastname, index) {
      //console.log(motherLastname);
      //console.log(index);
      if (motherLastname === "") {
        this.motherLastnameIsValidArray.splice(index, 1, false);
        //console.log(this.motherLastnameIsValidArray[index]);
      } else if (motherLastname !== "") {
        this.motherLastnameIsValidArray.splice(index, 1, true);
      }
      //console.log(this.motherLastnameIsValidArray.length);
    },

    societyValidationCompany(societyPercentage, index) {
      //console.log(societyPercentage);
      //console.log(index);
      if (societyPercentage === "") {
        this.societyPercentageCompanyIsValidArray.splice(index, 1, false);
        //console.log(this.societyPercentageCompanyIsValidArray[index]);
      } else if (societyPercentage !== "") {
        const value = this.percentageValidationTest(societyPercentage);
        if (value) {
          this.societyPercentageCompanyIsValidArray.splice(index, 1, true);
        } else {
          this.societyPercentageCompanyIsValidArray.splice(index, 1, false);
        }
      }
      //console.log(this.societyPercentageCompanyIsValidArray.length);
    },

    societyValidationPerson(societyPercentage, index) {
      //console.log("nuevo", societyPercentage);
      //console.log(index);
      if (societyPercentage === "") {
        this.societyPercentagePersonIsValidArray.splice(index, 1, false);
        //console.log(this.societyPercentagePersonIsValidArray[index]);
      } else if (societyPercentage !== "") {
        const value = this.percentageValidationTest(societyPercentage);
        //console.log(value);
        if (value) {
          this.societyPercentagePersonIsValidArray.splice(index, 1, true);
        } else {
          this.societyPercentagePersonIsValidArray.splice(index, 1, false);
        }
      }
      //console.log(this.societyPercentagePersonIsValidArray.length);
    },
    validateRutExist(rutRefs, rut, index, l) {
      //console.log("camm", this.inputsPartner);
      //console.log(index);
      if (rut !== "") {
        const arrayPartners = [];
        for (let i = 0; i < this.inputsPartner.length; i++) {
          if (i !== index) {
            arrayPartners.push(this.inputsPartner[i].rutPerson);
          }
        }
        //console.log("array", arrayPartners);
        const findAccionista = arrayPartners.indexOf(rut);
        //console.log(findAccionista);
        //console.log(arrayPartners[index], rut);
        if (findAccionista >= 0) {
          Swal.fire({
            icon: "warning",
            title: "El rut ya se encuentra ingresado como accionista.",
            //text: 'El máximo de caracteres es 100.',
            //footer: '<a href>Why do I have this issue?</a>'
          });
          this.inputsPartner[index].rutPerson = "";
          this.inputsPartner[index].name = "";
          this.inputsPartner[index].fatherLastname = "";
          this.inputsPartner[index].motherLastname = "";
          this.inputsPartner[index].societyPercentage = "";
        }
      }
    },

    checkInputsPartner() {
      for (let i = 0; i < this.firstPartnerArray.length; i++) {
        if (this.firstPartnerArray[i].company === true) {
          if (
            this.companyRutIsValidArray[i] === false ||
            this.firstPartnerArray[i].companyRut == "" ||
            this.businessNameIsValidArray[i] === false ||
            this.firstPartnerArray[i].businessName == "" ||
            this.societyPercentageCompanyIsValidArray[i] === false ||
            this.firstPartnerArray[i].societyPercentageCompany == ""
          ) {
            Swal.fire({
              icon: "error",
              title: "Error!",
              text:
                "Debe completar los campos del accionista antes de agregar otro.",
            });
            this.checkInputs.splice(i, 1, false);
          } else {
            this.checkInputs.splice(i, 1, true);
          }
        } else if (this.firstPartnerArray[i].person === true) {
          if (
            this.rutPersonIsValidArray[i] === false ||
            this.firstPartnerArray[i].rutPerson == "" ||
            this.nameIsValidArray[i] === false ||
            this.firstPartnerArray[i].name == "" ||
            this.fatherLastnameIsValidArray[i] === false ||
            this.firstPartnerArray[i].fatherLastname == "" ||
            this.motherLastnameIsValidArray[i] === false ||
            this.firstPartnerArray[i].motherLastname == "" ||
            this.societyPercentagePersonIsValidArray[i] === false ||
            this.firstPartnerArray[i].societyPercentagePerson == ""
          ) {
            Swal.fire({
              icon: "error",
              title: "Error!",
              text:
                "Debe completar los campos del accionista antes de agregar otro.",
            });
            this.checkInputs.splice(i, 1, false);
          } else {
            this.checkInputs.splice(i, 1, true);
          }
        }
      }
    },

    addPartner() {
      if (this.corregir) {
        this.checkInputsPartner();
        //console.log("checkIput: " + this.checkInputs);
        //console.log("counter: " + this.counter);
        const found = this.checkInputs.find((element) => element === false);
        //console.log(found);
        //console.log("length: " + this.partnersArray.length);
        if (found === undefined) {
          if (this.duplicates === true) {
            if (this.partnersArray.length < 1) {
              //console.log("partnersArray ES 0");
              this.counter = 0;
              if (this.companyPartner === true) {
                //console.log("counter: " + this.counter);
                this.firstPartnerArray[this.counter].person = false;
                this.firstPartnerArray[this.counter].rutPerson = "";
                this.firstPartnerArray[this.counter].name = "";
                this.firstPartnerArray[this.counter].fatherLastname = "";
                this.firstPartnerArray[this.counter].motherLastname = "";
                this.firstPartnerArray[this.counter].societyPercentagePerson =
                  "";
                this.partnersArray.push({
                  company: "",
                  person: "",
                  companyRut: "",
                  rutPerson: "",
                  businessName: "",
                  name: "",
                  fatherLastname: "",
                  motherLastname: "",
                  societyPercentageCompany: "",
                  societyPercentagePerson: "",
                });
                this.firstPartnerArray.push(this.partnersArray[this.counter]);
                this.companyRutIsValidArray.push("");
                this.businessNameIsValidArray.push("");
                this.societyPercentageCompanyIsValidArray.push("");
                this.rutPersonIsValidArray.push("");
                this.nameIsValidArray.push("");
                this.fatherLastnameIsValidArray.push("");
                this.motherLastnameIsValidArray.push("");
                this.societyPercentagePersonIsValidArray.push("");
                //console.log("partnersArray CON TODOS LOS VALORES");
                //console.log(this.partnersArray.length);
                //console.log(this.partnersArray);
                this.sumPartners = this.partnersArray.length;
                //console.log(this.sumPartners);
                //this.counter = parseInt(this.counter) + parseInt(1);
                ////console.log("COUNTER AFTER ADDING TO PARTNERS: " + this.counter);
              }

              if (this.personPartner === true) {
                //console.log("counter: " + this.counter);
                this.firstPartnerArray[this.counter].company = false;
                this.firstPartnerArray[this.counter].businessName = "";
                this.firstPartnerArray[this.counter].societyPercentageCompany =
                  "";
                this.partnersArray.push({
                  company: "",
                  person: "",
                  companyRut: "",
                  rutPerson: "",
                  businessName: "",
                  name: "",
                  fatherLastname: "",
                  motherLastname: "",
                  societyPercentageCompany: "",
                  societyPercentagePerson: "",
                });
                this.firstPartnerArray.push(this.partnersArray[this.counter]);
                this.companyRutIsValidArray.push("");
                this.businessNameIsValidArray.push("");
                this.societyPercentageCompanyIsValidArray.push("");
                this.rutPersonIsValidArray.push("");
                this.nameIsValidArray.push("");
                this.fatherLastnameIsValidArray.push("");
                this.motherLastnameIsValidArray.push("");
                this.societyPercentagePersonIsValidArray.push("");
                //console.log("partnersArray CON TODOS LOS VALORES");
                //console.log(this.partnersArray);
                //console.log(this.partnersArray.length);
                this.sumPartners = this.partnersArray.length;
                //console.log(this.sumPartners);
                //this.counter = parseInt(this.counter) + parseInt(1);
                //console.log("COUNTER AFTER ADDING TO PARTNERS: " + this.counter);
              }
            } else if (this.partnersArray.length > 0) {
              //console.log("in");
              if (this.partnersArray[this.counter].company === true) {
                //console.log(this.partnersArray[this.counter].company);
                //console.log("CLICKED ON COMPANY");
                //console.log(this.firstPartnerArray);
                //console.log(this.partnersArray);
                //console.log("on");
                this.partnersArray.push({
                  company: "",
                  person: "",
                  companyRut: "",
                  rutPerson: "",
                  businessName: "",
                  name: "",
                  fatherLastname: "",
                  motherLastname: "",
                  societyPercentageCompany: "",
                  societyPercentagePerson: "",
                });

                this.firstPartnerArray.push(
                  this.partnersArray[this.counter + 1]
                );
                this.companyRutIsValidArray.push("");
                this.businessNameIsValidArray.push("");
                this.societyPercentageCompanyIsValidArray.push("");
                this.rutPersonIsValidArray.push("");
                this.nameIsValidArray.push("");
                this.fatherLastnameIsValidArray.push("");
                this.motherLastnameIsValidArray.push("");
                this.societyPercentagePersonIsValidArray.push("");

                //console.log(this.partnersArray);
                //console.log(this.partnersArray.length);
                this.sumPartners = this.partnersArray.length;
                //console.log(this.sumPartners);
                this.counter = parseInt(this.counter) + parseInt(1);
                //console.log("COUNTER AFTER ADDING TO PARTNERS: " + this.counter);
              } else if (this.partnersArray[this.counter].person === true) {
                //console.log(this.partnersArray[this.counter].person);
                //console.log("CLICKED ON PERSON");

                //console.log(this.firstPartnerArray);
                //console.log(this.partnersArray);
                this.partnersArray.push({
                  company: "",
                  person: "",
                  companyRut: "",
                  rutPerson: "",
                  businessName: "",
                  name: "",
                  fatherLastname: "",
                  motherLastname: "",
                  societyPercentageCompany: "",
                  societyPercentagePerson: "",
                });

                this.firstPartnerArray.push(
                  this.partnersArray[this.counter + 1]
                );
                this.companyRutIsValidArray.push("");
                this.businessNameIsValidArray.push("");
                this.societyPercentageCompanyIsValidArray.push("");
                this.rutPersonIsValidArray.push("");
                this.nameIsValidArray.push("");
                this.fatherLastnameIsValidArray.push("");
                this.motherLastnameIsValidArray.push("");
                this.societyPercentagePersonIsValidArray.push("");
                //console.log(this.firstPartnerArray);
                //console.log(this.partnersArray);
                //console.log(this.partnersArray.length);
                this.sumPartners = this.partnersArray.length;
                //console.log(this.sumPartners);
                this.counter = parseInt(this.counter) + parseInt(1);
                //console.log("COUNTER AFTER ADDING TO PARTNERS: " + this.counter);
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Error!",
                  text: "Debe seleccionar el tipo de accionista.",
                });
              }
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "¡ERROR!",
              text:
                "Debe corregir RUT duplicado antes de agregar un nuevo accionista.",
            });
          }
        }
      } else {
        Swal.fire({
          icon: "warning",
          title: "Opción no disponible para corrección",
        });
      }
    },

    addPartnerParcialRecovery() {
      ////console.log(this.inputsPartner);
      this.partnersArray.push({
        company: "",
        person: "",
        companyRut: "",
        rutPerson: "",
        businessName: "",
        name: "",
        fatherLastname: "",
        motherLastname: "",
        societyPercentageCompany: "",
        societyPercentagePerson: "",
      });
      this.companyRutIsValidArray.push("");
      this.businessNameIsValidArray.push("");
      this.societyPercentageCompanyIsValidArray.push("");
      this.rutPersonIsValidArray.push("");
      this.nameIsValidArray.push("");
      this.fatherLastnameIsValidArray.push("");
      this.motherLastnameIsValidArray.push("");
      this.societyPercentagePersonIsValidArray.push("");

      // //console.log(this.inputsPartner);
      // this.partners.push(
      // this.inputsPartner);

      this.sumPartners = this.partnersArray.length;
      // //console.log(this.sumPartners);
    },

    // delete partner

    deletePartner(index) {
      if (this.corregir) {
        Swal.fire({
          title: "¿Está seguro de eliminar este accionista?",
          //text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire("Eliminado satisfactoriamente!", "", "success");
            //console.log(index);
            this.partnersArray.splice(index, 1);
            //console.log(this.partnersArray);
            this.firstPartnerArray.splice(index + 1, 1);
            //console.log(this.firstPartnerArray);
            this.counter = parseInt(this.counter) - parseInt(1);
            //console.log("COUNTER AFTER DELETE: " + this.counter);
            this.percentageTotal.splice(index + 1, 1);
            //console.log("totalPercentage AFTER DELETE: " + this.percentageTotal);
            this.total = this.percentageTotal.reduce(
              (a, b) => parseFloat(a) + parseFloat(b),
              0
            );
            //console.log("total AFTER DELETE: " + this.total);
            this.rutDuplicates();
          }
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Opción no disponible para corrección",
        });
      }
    },

    percentageValidation(percentage, index) {
      if (percentage < 1 || percentage > 100) {
        Swal.fire({
          icon: "warning",
          title: "Ingrese un número entre 1 y 100.",
          //text: 'El máximo de caracteres es 100.',
          //footer: '<a href>Why do I have this issue?</a>'
        });
        this.noZeroPercentage = false;
      } else {
        this.percentageTotal.splice(index, 1, percentage);

        this.total = this.percentageTotal.reduce(
          (a, b) => parseFloat(a) + parseFloat(b),
          0
        );

        //console.log(percentage);
        //console.log(this.percentageTotal);
        //console.log(this.total);

        if (this.total > 100) {
          this.societyPercentageIsValid = false;
          Swal.fire({
            icon: "warning",
            title: "El porcentaje no debe ser mayor a 100.",
            //text: 'El máximo de caracteres es 100.',
            //footer: '<a href>Why do I have this issue?</a>'
          });
        } else if (this.total < 0) {
          this.societyPercentageIsValid = false;
          Swal.fire({
            icon: "warning",
            title: "El porcentaje no debe ser menor a 0.",
            //text: 'El máximo de caracteres es 100.',
            //footer: '<a href>Why do I have this issue?</a>'
          });
        } else {
          this.societyPercentageIsValid = true;
        }
        this.noZeroPercentage = true;
      }
    },
    filesValidation() {
      if (this.vueDropzoneFileTwo == "" && this.files == "") {
        this.dropzoneTwoIsValid = false;
        Swal.fire({
          icon: "warning",
          title: "Debe agregar archivos antes de continuar.",
          //text: 'El máximo de caracteres es 100.',
          //footer: '<a href>Why do I have this issue?</a>'
        });
        //alert("Debe agregar archivos antes de continuar.");
      } else {
        this.dropzoneTwoIsValid = true;
      }
    },

    goStepOne() {
      //this.$router.push({ name: "StepOne" });
      // rutIsValid se utiliza en el paso 1, y al avanzar a paso 2 se setea en true, entonces al oprimir
      this.setRutIsValid(true);
      this.setStepOneValue(true);
      this.setStepTwoValue(false);
    },

    checkFormStepTwo() {
      if (this.corregir) {
        this.employeesTotalValidation();

        this.rangeValidation();

        this.firstPercentageValidation();

        this.secondPercentageValidation();

        this.volumeValidation();

        this.declaracionValidation();

        if (this.total > 100) {
          this.societyPercentageIsValid = false;
        } else {
          this.societyPercentageIsValid = true;
        }

        /*if (this.noZeroPercentage === false) {
              this.societyPercentageIsValid = false;
            } else {
              this.societyPercentageIsValid = true;
            }*/

        if (this.vueDropzoneFileTwo == "" && this.files == "") {
          this.dropzoneTwoIsValid = false;
          Swal.fire({
            icon: "warning",
            title: "Debe agregar archivos antes de continuar.",
            //text: 'El máximo de caracteres es 100.',
            //footer: '<a href>Why do I have this issue?</a>'
          });
          //alert("Debe agregar archivos antes de continuar.");
        } else {
          this.dropzoneTwoIsValid = true;
        }

        this.nameValidation();

        this.fatherLastnameValidation();

        this.motherLastnameValidation();

        //console.log("primer porcentaje acumulado",this.societyPercentageIsValid);
        //console.log("segundo porcent", this.secondPercentageIsValid);
        //console.log("tercer porcent", this.firstPercentageIsValid);
        //console.log("rutValid", this.rutIsValid);

        /* Company Partner variables to check*/
        let partnerType;
        let rutC;
        let bidness;
        let societyCompany;
        /* Person Partner variables to check*/
        let rutP;
        let nameP;
        let father;
        let mother;
        let societyPerson;
        for (let i = 0; i < this.firstPartnerArray.length; i++) {
          if (
            this.firstPartnerArray[i].company === "" &&
            this.firstPartnerArray[i].person === ""
          ) {
            partnerType = false;
          } else {
            partnerType = true;
            if (this.firstPartnerArray[i].company === true) {
              if (
                this.companyRutIsValidArray[i] === false ||
                this.firstPartnerArray[i].companyRut === ""
              ) {
                this.companyRutIsValidArray.splice(i, 1, false);
                rutC = false;
                //console.log(rutC);
              } else {
                rutC = true;
              }
              if (
                this.businessNameIsValidArray[i] === false ||
                this.firstPartnerArray[i].businessName === ""
              ) {
                this.businessNameIsValidArray.splice(i, 1, false);
                bidness = false;
                //console.log(bidness);
              } else {
                bidness = true;
              }
              if (
                this.societyPercentageCompanyIsValidArray[i] === false ||
                this.firstPartnerArray[i].societyPercentageCompany === ""
              ) {
                this.societyPercentageCompanyIsValidArray.splice(i, 1, false);
                societyCompany = false;
                //console.log(societyCompany);
              } else {
                societyCompany = true;
              }
            } else if (this.firstPartnerArray[i].person === true) {
              if (
                this.rutPersonIsValidArray[i] === false ||
                this.firstPartnerArray[i].rutPerson === ""
              ) {
                this.rutPersonIsValidArray.splice(i, 1, false);
                rutP = false;
                //console.log(rutP);
              } else {
                rutP = true;
              }
              if (
                this.nameIsValidArray[i] === false ||
                this.firstPartnerArray[i].name === ""
              ) {
                this.nameIsValidArray.splice(i, 1, false);
                nameP = false;
                //console.log(nameP);
              } else {
                nameP = true;
              }
              if (
                this.fatherLastnameIsValidArray[i] === false ||
                this.firstPartnerArray[i].fatherLastname === ""
              ) {
                this.fatherLastnameIsValidArray.splice(i, 1, false);
                father = false;
                //console.log(father);
              } else {
                father = true;
              }
              if (
                this.motherLastnameIsValidArray[i] === false ||
                this.firstPartnerArray[i].motherLastname === ""
              ) {
                this.motherLastnameIsValidArray.splice(i, 1, false);
                mother = false;
                //console.log(mother);
              } else {
                mother = true;
              }
              if (
                this.societyPercentagePersonIsValidArray[i] === false ||
                this.firstPartnerArray[i].societyPercentagePerson === ""
              ) {
                this.societyPercentagePersonIsValidArray.splice(i, 1, false);
                societyPerson = false;
                //console.log(societyPerson);
              } else {
                societyPerson = true;
              }
            }
          }
        }

        if (
          this.selectedRange == "" ||
          this.declaracionIsValid == false ||
          this.firstPercentage == "" ||
          this.firstPercentageIsValid == false ||
          this.secondPercentage == "" ||
          this.secondPercentageIsValid == false ||
          this.volume == "" ||
          (this.vueDropzoneFileTwo == "" && this.files == "") ||
          partnerType === false ||
          rutC === false ||
          rutP === false ||
          bidness === false ||
          societyCompany === false ||
          nameP === false ||
          father === false ||
          mother === false ||
          societyPerson === false ||
          this.totalEmployeesIsValid == false ||
          this.societyPercentageIsValid === false ||
          this.noZeroPercentage === false ||
          this.duplicates === false
        ) {
          if (this.societyPercentageIsValid === false) {
            Swal.fire({
              icon: "warning",
              title: "Por favor, corregir porcentaje. No debe ser mayor a 100.",
              didDestroy: () => {
                window.scrollTo(0, 0);
              },
              //text: 'El máximo de caracteres es 100.',
              //footer: '<a href>Why do I have this issue?</a>'
            });
          } else if (this.duplicates === false) {
            Swal.fire({
              icon: "warning",
              title: "Por favor, corregir RUT duplicado antes de continuar.",
              didDestroy: () => {
                window.scrollTo(0, 0);
              },
              //text: 'El máximo de caracteres es 100.',
              //footer: '<a href>Why do I have this issue?</a>'
            });
          } else if (this.noZeroPercentage === false) {
            Swal.fire({
              icon: "warning",
              title: "Por favor, ingrese un Porcentaje entre 1 y 100.",
              didDestroy: () => {
                window.scrollTo(0, 0);
              },
              //text: 'El máximo de caracteres es 100.',
              //footer: '<a href>Why do I have this issue?</a>'
            });
          } else if (this.noZeroPercentage === false) {
            Swal.fire({
              icon: "warning",
              title: "Por favor, ingrese un Porcentaje entre 1 y 100.",
              didDestroy: () => {
                window.scrollTo(0, 0);
              },
              //text: 'El máximo de caracteres es 100.',
              //footer: '<a href>Why do I have this issue?</a>'
            });
          } else {
            Swal.fire({
              icon: "warning",
              title: "Debe completar todos los campos requeridos.",
              didDestroy: () => {
                window.scrollTo(0, 0);
              },
              //text: 'El máximo de caracteres es 100.',
              //footer: '<a href>Why do I have this issue?</a>'
            });
          }

          this.formIsValid = false;
          ////console.log('Fue falso');
        } else {
          ////console.log('Fue true');
          this.formIsValid = true;
        }

        if (this.formIsValid == true) {
          this.saveContinueStepTwo();
          // METODO A ANALIZAR
          //this.saveSteptwo();
          //console.log("saliendo de step two");
          //this.$router.push({ name: "StepThree" });
          this.setStepTwoValue(false);
          this.setStepThreeValue(true);
        }
      } else {
        this.saveContinueStepTwo();
        this.setStepTwoValue(false);
        this.setStepThreeValue(true);
      }
    },

    saveContinueStepTwo() {
      this.companyBackgroundUploadTwo();
      var dropzoneArrayTwo = this.formatedNameStepTwo;
      //console.log("archivos", this.files);
      /*for (const key in this.vueDropzoneFileTwo) {
          //console.log("key", key);
          //console.log("value", this.vueDropzoneFileTwo[key].name);
          dropzoneArrayTwo.push(this.vueDropzoneFileTwo[key].name);
        }*/
      dropzoneArrayTwo = dropzoneArrayTwo.concat(this.files);
      //console.log("Dropzone file array before saving in object" + dropzoneArrayTwo);

      this.stepTwoObject.push({
        stepTwo: {
          totalEmployees: this.selectedTotalEmployees,
          range: this.selectedRange,
          firstPercentage: this.firstPercentage,
          secondPercentage: this.secondPercentage,
          volume: this.volume,
          filesStepTwo: dropzoneArrayTwo,
          //partners: this.sumPartners,
          //inputs: this.inputsPartner,
          partners: this.firstPartnerArray,
          counter: this.counter,
          declaracion: this.declaracion
        },
      });
      //console.log(this.stepTwoObject);
      this.saveCompletedForm([this.stepTwoObject, 2]);
      if (!this.tieneCorreccion) {
        this.savePostStepTwo();
      } else {
        //console.log("TIENE CORRECCION - NO SE GUARDA EN BASE");
      }
      // this.getRutParnersGlobal(this.partners);
      this.cargaRutParners(); // metodo para cargar el rutpartners

      //console.log(this.completedForm);
      this.stepTwoObject = [];
      this.clearDropzone();
    },

    cargaRutParners() {
      const array = [];
      const primerElemento = this.firstPartnerArray[0];
      let rut;

      // Cargamos el rutPartnerGlobal que contiene un rut
      if (primerElemento.company) {
        rut = primerElemento.companyRut;
      } else {
        rut = primerElemento.rutPerson;
      }
      this.getRutParnerGlobal(rut); //instanciamos el rutGlobal

      // Cargamos el array de ruts
      this.firstPartnerArray.forEach((element) => {
        // //console.log(element);
        if (element.company) {
          array.push({
            rutPerson: element.companyRut,
          });
        } else {
          // de no cumplir, seria una persona fisica
          array.push({
            rutPerson: element.rutPerson,
          });
        }
      });
      this.getRutParnersGlobal(array); //instanciamos el array
    },

    saveSteptwo() {
      //this.addPartner();
      Swal.fire({
        title: "¿Está seguro que desea guardar su postulación?",
        //text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "btn btn-danger",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          //console.log(this.partnersArray.length);
          this.companyBackgroundUploadTwo();
          var dropzoneArrayTwo = this.formatedNameStepTwo;
          /*for (const key in this.vueDropzoneFileTwo) {
              //console.log("key", key);
              //console.log("value", this.vueDropzoneFileTwo[key].name);
              dropzoneArrayTwo.push(this.vueDropzoneFileTwo[key].name);
            }*/
          dropzoneArrayTwo = dropzoneArrayTwo.concat(this.files);
          //console.log("Dropzone file array before saving in object" + dropzoneArrayTwo);

          /*this.firstPartnerArray.splice(this.firstPartnerArray.length, 1, this.partnersArray[this.counter]);
            //console.log(this.firstPartnerArray);*/

          this.stepTwoObject.push({
            stepTwo: {
              totalEmployees: this.selectedTotalEmployees,
              range: this.selectedRange,
              firstPercentage: this.firstPercentage,
              secondPercentage: this.secondPercentage,
              volume: this.volume,
              filesStepTwo: dropzoneArrayTwo,
              //partners: this.sumPartners,
              partners: this.firstPartnerArray,
              counter: this.counter,
              declaracion: this.declaracion
            },
          });
          //console.log(this.stepTwoObject);
          this.saveCompletedForm([this.stepTwoObject, 2]);
          this.savePostStepTwo();
          this.getRutParnersGlobal(this.partners);
          this.getRutParnerGlobal(this.inputsPartner[0].rutPerson);
          this.getStepTwoRequest(this.nroSolicitud);
          this.clearDropzone();
          //console.log(this.completedForm);
          this.stepTwoObject = [];
          Swal.fire("¡Datos guardados satisfactoriamente!", "", "success");
        }
      });
    },

    savePostStepTwo: function() {
      let stepTwoObject = this.completedForm;
      //console.log(this.completedForm[2]);
      let data = JSON.stringify(stepTwoObject);
      //console.log("Step two Object ready to be sent: " + data);
      //console.log("stepTwoObject length: " + stepTwoObject.length);
      if (this.completedForm.length > 0) {
        axios
          .post(this.URL + "/guardarParcial", data)
          .then((response) => {
            //console.log(response.data);
          })
          .catch(function(error) {
            //console.log("AXIOS ERROR: ", error);
          });
        /*this.completedForm.pop();
          //console.log(this.completedForm);*/
      } else {
        Swal.fire({
          icon: "warning",
          title: "¡Error al guardar, intente de nuevo!",
          //text: 'El máximo de caracteres es 100.',
          //footer: '<a href>Why do I have this issue?</a>'
        });
        //alert("¡Error al guardar, intente de nuevo!");
      }
    },
    chargeObjectData() {
      this.objectData = this.$store.getters.getterObjectData[2].stepTwo;
    },

    removeFileFromFiles(index) {
      if (index > -1 && this.corregir) {
        Swal.fire({
          title: "¿Está seguro de eliminar este archivo?",
          //text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire("Eliminado satisfactoriamente!", "", "success");
            //console.log("eliminando el elemento con indice " + index);
            this.files.splice(index, 1);
          }
        });
      } else {
        if (this.corregir === false) {
          Swal.fire({
            icon: "warning",
            title: "Opción no disponible para corrección",
          });
        }
      }
    },

    // traemos el objeto de nuevo
    getRut() {
      let routeNumber = this.$route.params.id;
      let number;
      let rut;
      ////console.log(routeNumber);
      axios
        .get(this.URL + "/getRut/" + routeNumber)
        .then((response) => {
          let data = response.data;
          number = data[0].requestNumber;
          rut = data[0].rut;
          if (routeNumber == number) {
            ////console.log("Match requestNumber");
            // this.rutCompany = rut;
            this.getNroSolicitud(rut);
          } else {
          }
          ////console.log(this.tipoSocDocs);
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },

    clearDropzone() {
      if(this.tieneCorreccion = false){
    this.$refs.myVueDropzone2.removeAllFiles(true);
    console.log('files aquip', this.files);
    this.setFormatedName([]);
    }
    },

    getNroSolicitud(rut) {
      axios
        .get(this.urlBase + "/buscarPostulante/" + rut)
        .then((response) => {
          const datosBasicos = response.data;
          ////console.log(datosBasicos);
          const nroSolicitud = datosBasicos[0].nro_solicitud;
          //this.nroSolicitudObj(this.nroSolicitud);
          //console.log(nroSolicitud);
          setTimeout(this.getStepTwoRequest(nroSolicitud), 3000);
          //this.getSocietyType(this.nroSolicitud);
          this.validationStep(nroSolicitud);
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
      ////console.log(this.nroSolicitud);
      //this.getStepOneRequest(this.nroSolicitud);
    },

    // metodo que verifica la correccion del formulario
    validationStep(nroSolicitud) {
      //console.log("Numero de SOLICITUD", nroSolicitud);

      axios
        .get(this.URL + "/validarCorreccion/" + nroSolicitud + "-2")
        .then((response) => {
          let data = response.data;
          //console.log("Response Validar Correccion", data);

          if (data.ESTADO !== "PENDIENTE A ENVÍO") {
            //CORREGIR_PASO viene true si se debe volver a ingresar informacion y false si no se debe corregir, es decir es valido
            this.corregir = data.CORREGIR_PASO;
            this.tieneCorreccion = true; // indica que tomara el camino de correccion
          }
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },

    /* findPostulanteExist(rut, index) {

          //console.log(index);
          //console.log('Partner Global stepTwo',this.rutPartnerGlobal)

          if (this.rutPartnerGlobal !== rut ) { 

             const rutString = new String(rut) 
              // //console.log(rutString, 'rutString');
              axios.get(this.urlBase+'/validatePatrocinantes/' + rutString).then((response) => {
          
                this.dataValidaciones = response.data;
                if (Object.keys(this.dataValidaciones).length !== 0 && this.dataValidaciones.Representante !== ""
                ) {
                  if (this.rutParticipante !== this.rutParticipante2) {
                    if(this.rutParticipante2 !== "") {
                      this.nombreParticipante2 = this.dataValidaciones.Representante.nombre;
                      this.focus(ref);
                      this.estado2 = this.dataValidaciones.Estado;
                      //this.estado = this.dataValidaciones.Estado;
                      this.noExiste2 = true;
                      this.rutNoIdentico = true;
                       if (this.dataValidaciones.grupos !== '' && this.dataValidaciones.grupos !== 'undefined') {
                         this.grupos2 = {
                           name: this.dataValidaciones.grupos.GRUPO,
                           perId: this.dataValidaciones.grupos.PER_ID
                         }
                       }
                      }
                } else {
                  if (this.rutParticipante !== "" && this.rutParticipante2 !== "") {
                    this.rutNoIdentico = false;
                    
                    //this.nombreParticipante2 = "";
                    // alert("Los patrocinantes deben tener rut distinto");
                    Swal.fire({
                            icon: 'warning',
                            title: 'Los patrocinantes deben tener rut distinto',
                          })
  
                  }
                  this.rutParticipante2 = "";
                  this.nombreParticipante2 = "";
                }
               /* } else {
                  // alert("El Patrocinante no existe");
                      this.noExiste2 = false;
                      this.rutParticipante2 = "";
                      this.nombreParticipante2 = "";
                      this.emailParticipante2 = "";
                      this.telefonoParticipante2 = "";
                      Swal.fire({
                        icon: 'warning',
                        title: 'No existe socio activo asociado al rut',
                      })

                      
                }
  
              }).catch(function (error) {
              //console.log("AXIOS ERROR: ", error);
              });
          } else {
              // alert("No puede tener el mismo RUT de un Accionista");
              Swal.fire({
                            icon: 'warning',
                            title: 'No puede tener el mismo RUT de un Accionista',
                          })
              this.firstPartnerArray[index].companyRut=""
            }
         }).catch(function (error) {
              //console.log("AXIOS ERROR: ", error);
              });
          }
      },*/

    findPostulanteExist(rut, index) {
      axios
        .get(this.urlBase + "/buscarPostulante/" + rut)
        .then((response) => {
          ////console.log(response);
          this.postulanteExistente = response.data;
          if (Object.keys(this.postulanteExistente).length !== 0) {
            if (this.postulanteExistente[0].status == "2") {
              
              this.firstPartnerArray[index].companyRut;
              this.firstPartnerArray[index].rutPerson;
            } else if(this.postulanteExistente[0].rut == this.rutGlobal){
              Swal.fire({
                icon: "warning",
                title:
                  "El rut ingresado corresponde al postulante y no puede ser su propio accionista",
                //text: 'El máximo de caracteres es 100.',
                //footer: '<a href>Why do I have this issue?</a>'
              });
              //alert("Ya existe una postulación asociada al Rut ingresado");
              //this.rutExistente = false;
              //this.rut = "";
              this.firstPartnerArray[index].companyRut = "";
              this.firstPartnerArray[index].rutPerson = "";
            }
          }
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },

    ValidationAccionista(rut, index) {
      axios
        .get(this.urlBase + "/ValidaAccionista/" + rut)
        .then((response) => {
          // //console.log(response, 'hola');

          this.entidadCchc = response.data;
          // //console.log(this.entidadCchc, 'hola CChc')
          if (Object.keys(this.entidadCchc).length !== 0) {
            if (!this.entidadCchc[0].PER_RUT == rut) {
              this.firstPartnerArray[index].companyRut;
              this.firstPartnerArray[index].rutPerson;
            } else {
              Swal.fire({
                icon: "warning",
                title:
                  "El rut ingresado corresponde a una entidad CChC y no puede ser accionista",
                //text: 'El máximo de caracteres es 100.',
                //footer: '<a href>Why do I have this issue?</a>'
              });
              //alert("Ya existe una postulación asociada al Rut ingresado");
              //this.rutExistente = false;
              //this.rut = "";
              this.firstPartnerArray[index].companyRut = "";
              this.firstPartnerArray[index].rutPerson = "";
            }
          }
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
    },

    getStepTwoRequest(number) {
      // //console.log('number',number)
      let requestNumber = number;
      axios
        .get(this.urlBase + "/paso1/" + requestNumber)
        .then((response) => {
          let stepOneSaved = response.data;
          if(stepOneSaved.length){
            if (stepOneSaved[0].object !== "") {
              this.getStepTwo = JSON.parse(stepOneSaved[0].object);
              const estado = JSON.parse(stepOneSaved[0].estado);
              const idConecta = JSON.parse(stepOneSaved[0].idConecta); // nueva modificacion al back
              if ((estado === 1 && idConecta == null) || estado === 3) {
                // TRAEMOS LA VARIABLE GLOBAL CON EL OBJETO ALMACENADO
                this.storeObjectStepTwo = this.$store.getters.getterObjetoStepTwo;
                //console.log("STORE// objetoStepTwo: " + this.storeObjectStepTwo);
                if (this.storeObjectStepTwo.length == 1) {
                  this.$store.commit("setObjetoStepTwo", this.getStepTwo);
                  this.recoveryDataForm(this.getStepTwo);
                } else {
                  this.recoveryDataForm(this.storeObjectStepTwo);
                }
              }
              if (estado === 2 || estado === 0) {
                // SE PODRIA EMPLEAR PARA REDIRECCION A HOME
                //console.log("Estado de solicitud Caducada o Inactiva");
                Swal.fire({
                icon: 'warning',
                title: 'Solicitud de postulación caducada, para continuar debe iniciar un nuevo proceso.',      
                });
              }
              //console.log("Objeto que se recupera en el paso 2", this.getStepTwo);
            } else {
              this.setAuth(false);
            }
          }
       
        })
        .catch(function(error) {
          //console.log("AXIOS ERROR: ", error);
        });
        this.formLoaded = true;
    },

    recoveryDataForm(objectData) {
      //const stepTwo = this.$store.getters.getterObjectData[2].stepTwo
      
      if (objectData[2].stepTwo) {
        const stepTwo = objectData[2].stepTwo;
        // //console.log('paso 2',stepTwo);

       

        if (stepTwo) {

          if (stepTwo.declaracion) {
          this.declaracion = stepTwo.declaracion;
          }
          /*
            totalEmployees: "1"
            range: "3"
            partners: 0
            firstPercentage: "7645"
            secondPercentage: "56"
            volume: "87665"
            filesStepTwo: Array(2)
            inputs: Array(1)


            totalEmployees: this.selectedTotalEmployees,
            range: this.selectedRange,
            firstPercentage: this.firstPercentage,
            secondPercentage: this.secondPercentage,
            volume: this.volume,
            filesStepTwo: dropzoneArrayTwo,
            partners: this.sumPartners,
            inputs: this.inputsPartner
           */
          // Trabajadores
         

          if (stepTwo.totalEmployees) {
            this.$store.commit("setTotalEmployees", stepTwo.totalEmployees);
          }

          // Financiero
          if (stepTwo.range) {
            this.$store.commit("setRange", stepTwo.range);
          }
          if (stepTwo.firstPercentage) {
            this.$refs.input.className = "input u-mb30 uf active";
            this.firstPercentage = stepTwo.firstPercentage;
            //this.firstPercentageValidation(this.$refs.input)
            // SE DETECTO que el metodo de arriba no recibe parametro
            this.firstPercentageValidation();
          }
          if (stepTwo.secondPercentage) {
            this.$refs.society.className = "input u-mb60 percent active";
            this.secondPercentage = stepTwo.secondPercentage;
            this.secondPercentageValidation();
          }
          if (stepTwo.volume) {
            this.$refs.volume.className = "input u-mb30 uf active";
            this.volume = stepTwo.volume;
            this.volumeValidation();
          } /*else if (stepTwo.volume == '') {
            this.$refs.volume.className = 'input u-mb30 uf'
            this.volume = stepTwo.volume
            this.volumeValidation()
          }*/

          // Documentos
          /*//console.log('archivos STEPTWO',stepTwo.filesStepTwo);
          if (stepTwo.filesStepTwo.length > 0) {
            this.files = stepTwo.filesStepTwo;
            this.filesValidation();
            
          }*/

          //console.log("archivos STEPTWO", stepTwo.filesStepTwo);

          //console.log(stepTwo.filesStepTwo.length);

          const oldArrayFile = [];
          const arrayFile = [];
          /*for (let i = 0; i<stepTwo.filesStepTwo.length; i++) {
            //console.log(stepTwo.filesStepTwo[i])
            //console.log(stepTwo.filesStepTwo[i].upload)
            //console.log(stepTwo.filesStepTwo[i].upload.filename)
            oldArrayFile.push(stepTwo.filesStepTwo[i].upload.filename);
          }*/
          /*for (const key in stepTwo.filesStepTwo) {
            //console.log(key)
            //console.log(stepTwo.filesStepTwo[key])
            //console.log(stepTwo.filesStepTwo[key].upload)
            //console.log(stepTwo.filesStepTwo[key].upload.name)
          }*/
          if (stepTwo.filesStepTwo.length > 0) {
            //this.files = stepTwo.filesStepTwo;
            for (let i = 0; i < stepTwo.filesStepTwo.length; i++) {
              if (stepTwo.filesStepTwo[i].upload?.filename === undefined) {
                arrayFile.push(normalizeText(stepTwo.filesStepTwo[i]));
              } else {
                //console.log(stepTwo.filesStepTwo[i]);
                //console.log(stepTwo.filesStepTwo[i].upload.filename);
                oldArrayFile.push(
                  normalizeText(stepTwo.filesStepTwo[i].upload.filename)
                );
              }
            }

            if (oldArrayFile.length > 0) {
              this.files = oldArrayFile;
              //console.log(this.files);
            } else {
              //this.files = stepTwo.filesStepTwo;
              this.files = arrayFile;
              //console.log(this.files);
            }

            //this.files = oldArrayFile;
            this.filesValidation();
          }

          // Patenrs
          const accionistas = [];
          if (stepTwo.inputs && stepTwo.inputs.length > 0) {
            // ADAPTACION DEL VIEJO OBJETO
            /**
               * stepTwo
               * ...
                  inputs
                      0
                          rutPerson : "13997013-6"
                          name : "Katherine"
                          fatherLastname : "Basaure"
                          motherLastname : "Ormazabal"
                          societyPercentage : "100"
              */
            const inputs = stepTwo.inputs;

            inputs.forEach((el) => {
              let obj = {};
              if (el.fatherLastname !== "" && el.motherLastname !== "") {
                //accionista individual
                obj = {
                  company: "",
                  person: true,
                  companyRut: "",
                  businessName: "",
                  societyPercentageCompany: "",
                  rutPerson: el.rutPerson,
                  name: el.name,
                  fatherLastname: el.fatherLastname,
                  motherLastname: el.motherLastname,
                  societyPercentagePerson: el.societyPercentage,
                };
              } else {
                //accionista empresa
                obj = {
                  company: true,
                  person: "",
                  companyRut: el.rutPerson,
                  businessName: el.name,
                  societyPercentageCompany: el.societyPercentage,
                  rutPerson: "",
                  name: "",
                  fatherLastname: "",
                  motherLastname: "",
                  societyPercentagePerson: "",
                };
              }
              accionistas.push(obj);
              //console.log(//console.log(JSON.stringify(accionistas)));
            });
          }

          if (stepTwo.partners.length > 0 || accionistas.length > 0) {
            /*if (stepTwo.partners[0].societyPercentageCompany) {
                this.percentageValidation(stepTwo.partners[0].societyPercentageCompany);
              }
              if (stepTwo.partners[0].societyPercentagePerson) {
                this.percentageValidation(stepTwo.partners[0].societyPercentagePerson);
              }*/
            this.rec_activated = true;
            if (stepTwo.partners.length > 0) {
              // //console.log('nuevo')
              this.composicionAccionaria = stepTwo.partners;
            } else {
              // //console.log('viejo')
              this.composicionAccionaria = accionistas;
            }
            // this.composicionAccionaria = stepTwo.partners;

            // cargado el array de elementos dinamicos, seteamos la bandera para activar las clases en false
            this.banderaActivarClases = false;

            //cargamos First Paterns Array
            this.firstPartnerArray = this.composicionAccionaria;
            this.cargaRutParners();
            ////console.log('FIRST PARTNERS ARRAY',this.firstPartnerArray);
            this.companyPartner = this.firstPartnerArray[0].company;
            this.personPartner = this.firstPartnerArray[0].person;
            //check rut duplicates i=0
            const checkTempRutDuplicate = [];
            if (this.companyPartner) {
              checkTempRutDuplicate.push(this.firstPartnerArray[0].companyRut);
            } else if (this.personPartner) {
              checkTempRutDuplicate.push(this.firstPartnerArray[0].rutPerson);
            }

            this.composicionAccionaria.forEach((element, index) => {
              /*
                  company : true
                  person : ""
                  companyRut : ""
                  businessName : ""
                  societyPercentageCompany : ""
                  rutPerson : ""
                  name : ""
                  fatherLastname : ""
                  motherLastname : ""
                  societyPercentagePerson : ""}
                */

              //creamos nuevo elemento dentro del form
              /*alert(JSON.stringify(element))
               alert(JSON.stringify(element.societyPercentageCompany))*/
              if (element.societyPercentageCompany !== "") {
                this.percentageValidation(
                  element.societyPercentageCompany,
                  index
                );
              }

              if (element.societyPercentagePerson !== "") {
                /*alert("entró");*/
                this.percentageValidation(
                  element.societyPercentagePerson,
                  index
                );
              }

              let i = index - 1;

              if (index > 0 && index < this.composicionAccionaria.length) {
                this.addPartnerParcialRecovery();
                this.partnersArray[i] = element;

                if (element.companyRut) {
                  checkTempRutDuplicate.push(element.companyRut);
                }

                if (element.rutPerson) {
                  checkTempRutDuplicate.push(element.rutPerson);
                }

                // if (element.companyRut) {
                //   this.partnersArray[i].companyRut = element.companyRut;
                // }
                // if (element.businessName) {
                //   this.partnersArray[i].businessName = element.businessName;
                // }
                /*if (element.societyPercentageCompany) {

                     this.partnersArray[i].societyPercentageCompany = element.societyPercentageCompany;
                     alert(JSON.stringify(this.partnersArray[i].societyPercentageCompany));
                   }*/

                // if (element.rutPerson) {
                //   this.partnersArray[i].rutPerson = element.rutPerson;
                // }
                // if (element.name) {
                //   this.partnersArray[i].name = element.name;
                // }
                // if (element.fatherLastname) {
                //   this.partnersArray[i].fatherLastname = element.fatherLastname;
                // }
                // if (element.motherLastname) {
                //   this.partnersArray[i].motherLastname = element.motherLastname;
                // }
                /*if (element.societyPercentagePerson) {
                     this.partnersArray[i].societyPercentagePerson = element.societyPercentagePerson;
                   }*/

                //  //console.log('COMPANY', element.company);
                //  //console.log('PERSON', element.person);
                if (element.company) {
                  this.partnersArray[i].company = true;
                  this.partnersArray[i].person = false;
                } else {
                  this.partnersArray[i].person = true;
                  this.partnersArray[i].company = false;
                }
              }
            });

            // validamos rut duplicados - se crea un array con todos los ruts durante la carga
            // ahora con ese array validamos que no se repitan

            this.duplicates = true;
            checkTempRutDuplicate.forEach((rut, i) => {
              const tempArray = checkTempRutDuplicate;
              tempArray.splice(i, 1);
              const found = tempArray.indexOf(rut);
              if (found !== -1) {
                this.duplicates = false;
              }
            });

            //una vez cargado el array de elementos dinamicos, activamos la bandera para activar las clases
            this.banderaActivarClases = true;

            // seccion para correccion para accionistas | deshabilitar campos
            if (this.corregir === false) {
              // //console.log('DESHABILITANDO CAMPOS');
              this.deshabilitarCampos();
              // //console.log('FORMULARIO VALIDADO');
            } else {
              // //console.log('SE ACTIVO LA CORRECCION');
            }
          }
          // //console.log('Numero de accionistas',stepTwo.partners);
          if (stepTwo.partners) {
            this.sumPartners = stepTwo.partners;
          }
          // //console.log('Numero de accionistas contador',stepTwo.counter);
          if (stepTwo.counter) {
            this.counter = stepTwo.counter;
          } else {
            if (this.firstPartnerArray.length > 2) {
              this.counter = this.firstPartnerArray.length - 2;
            } else {
              this.counter = 0;
            }
          }

          // seccion para correccion
          if (this.corregir === false) {
            ////console.log('DESHABILITANDO vueDropZone');
            this.$refs.myVueDropzone2.disable();
            // //console.log('FORMULARIO VALIDADO');
          } else {
            // //console.log('SE ACTIVO LA CORRECCION');
          }
        }
      } else {
        //console.log("No existe recuperacion parcial para el Step Two");
      }
    },

    activatedClass() {
      this.composicionAccionaria.forEach((element, index) => {
        let test;
        let i = index - 1;
        if (index > 0) {
          if (element.company) {
            this.$refs.rut[i].className = "input item-content u-mb70 active";
            this.$refs.name[i].className = "input item-content u-mb70 active";
            this.$refs.societyPercentage[i].className =
              "input item-content u-mb70 active";
          } else {
            this.$refs.rut[i].className = "input item-content u-mb70 active";
            this.$refs.name[i].className = "input item-content u-mb70 active";
            this.$refs.societyPercentage[i].className =
              "input item-content u-mb70 active";
            this.$refs.lastname[i].className =
              "input item-content u-mb70 active";
            this.$refs.motherLastname[i].className =
              "input item-content u-mb70 active";
          }
        }
      });
      //  this.$refs.firstRut.className = 'input item-content u-mb70 active';
      if (this.companyPartner) {
        this.$refs.firstRut.className = "input item-content u-mb70 active";
        this.$refs.firstName.className = "input item-content u-mb70 active";
        this.$refs.firstSocietyPercentage.className =
          "input item-content u-mb70 active";
      }
      if (this.personPartner) {
        this.$refs.secondRut.className = "input item-content u-mb70 active";
        this.$refs.secondName.className = "input item-content u-mb70 active";
        this.$refs.secondLastname.className =
          "input item-content u-mb70 active";
        this.$refs.secondMotherLastname.className =
          "input item-content u-mb70 active";
        this.$refs.secondSocietyPercentage.className =
          "input item-content u-mb70 active";
      }

      if (this.corregir === false) {
        this.deshabilitarCampos();
        //console.log("FORMULARIO VALIDADO");
      } else {
        //console.log("SE ACTIVO LA CORRECCION");
      }
    },
    deshabilitarCampos() {
      //console.log("Deshabilitando campos");
      // deshabilitamos el vue drop zone
      // //console.log('composicion accionaria',this.composicionAccionaria);
      if (this.companyPartner) {
        this.$refs.rutPersonRefC.disabled = true;
        this.$refs.nameInputC.disabled = true;
        this.$refs.societyPercentageInputC.disabled = true;
      }
      if (this.personPartner) {
        this.$refs.rutPersonRefP.disabled = true;
        this.$refs.nameInputP.disabled = true;
        this.$refs.fatherLastnameInputP.disabled = true;
        this.$refs.motherLastnameInputP.disabled = true;
        this.$refs.societyPercentageInputP.disabled = true;
      }

      if (this.composicionAccionaria.length > 1) {
        this.composicionAccionaria.forEach((element, index) => {
          let i = index - 1;
          if (index < this.composicionAccionaria.length && index > 0) {
            if (element.company) {
              this.$refs.rutPersonRef[i].disabled = true;
              this.$refs.nameInput[i].disabled = true;
              this.$refs.societyPercentageInput[i].disabled = true;
            } else {
              this.$refs.rutPersonRef[i].disabled = true;
              this.$refs.nameInput[i].disabled = true;
              this.$refs.societyPercentageInput[i].disabled = true;
              this.$refs.fatherLastnameInput[i].disabled = true;
              this.$refs.motherLastnameInput[i].disabled = true;
            }
          }
        });
      }
      // esto se mantiene deshabilitado porque con un v-if se oculta el vue dropzone
      // this.$refs.myVueDropzone2.disabled();
    },

    test() {
      //this.companyBackgroundUpload();
    },
  },


  watch:{
    fileNames: function() {
      this.wasFilesChanged = true
    },
    showStepTwo: function (newValue) {
      if (!newValue && this.wasFilesChanged) this.wasFilesChanged = false
    }
  },

  computed: {
    ...mapState([
      "showStepTwo",
      "collapse",
      "selectedTotalEmployees",
      "selectedRange",
      "totalEmployees",
      "range",
      "rutPartnerGlobal",
      "rutGlobal",
      "rutIsValid",
      "vueDropzoneFileTwo",
      "completedForm",
      "tipoSocDocs",
      "URL",
      "objetoStepTwo",
      "globalRequestNumber",
      "rutGlobal",
      "nroSolicitudGlobal",
      "formatedNameStepTwo",
    ]),
    fileNames () {
      const rut = this.getStepTwo.length === 0 ? this.rutCompany : this.rutGlobal

      return this.vueDropzoneFileTwo.map(file => {
        //const fileName = (normalizeText( Date.now()+'_'+rut+'_'+file.name)).replace(/[^a-zA-Z_0-9-.]/g, '');    
		  const fileName = normalizeText( Date.now()+'_'+rut+'_'+file.name);
			const fileChange= fileName.replace(/[^a-zA-Z_0-9-.]/g, '');

        return fileChange
      })
    },
  },
  created() {
    this.getTotalEmployees();
    this.getRange();
    ////console.log('showStepTwo',this.$store.state.showStepTwo);
    this.getRut();
    // //console.log(this.partners);
    // //console.log(this.partners.length);
    // //console.log(this.completedForm);
    // this.chargeObjectData()
    //this.recoveryData()
  },
  updated() {
    // if(this.$store.state.showStepTwo && this.banderaActivarClases){
    /*if(this.banderaActivarClases){
        }*/
    if (this.rec_activated) {
      this.activatedClass();
    }
  },
};
</script>

<style>
.pointer {
  cursor: pointer !important;
}

*:disabled {
  color: #ccc;
  border-color: #ccc;
}

.errorDeclaracion {
  color: red;
}

.mx-input:disabled,
.mx-input.disabled {
  color: #ccc;
  background-color: #f0f0f0;
  z-index: initial;
  border-color: black;
}

i {
  z-index: 25;
}
label {
  z-index: 25;
}

select:disabled {
  opacity: 0.3;
}

.dropzone-custom-content {
  position: absolute;
  padding-top: 15%;
  left: 58%;
  transform: translate(-50%, -30%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
  width: 500px;
  height: 100px;
}

.border2 {
  /*background: url(../../assets/img/draganddrop.png) no-repeat !important;*/
  border: 1;
  /*height: 194px;
  width: 652px;*/
}

.border:hover {
  cursor: pointer;
}

.errorFile {
  font-size: 100%;
  color: red;
  position: relative;
  left: 100%;
}

.svg {
  background: url(../../assets/img/draganddrop-text.svg) no-repeat center;
  margin-left: -4%;
  height: 10px;
}

.vue-dropzone > .dz-preview .dz-error-message {
  margin-left: auto;
  margin-right: auto;
  margin-top: 25px;
  left: 0;
  width: 100%;
  text-align: center;
}

.vue-dropzone > .dz-preview .dz-remove {
  position: absolute;
  z-index: 30;
  color: #fff;
  margin-left: 15px;
  margin-bottom: 35px;
  padding: 10px;
  top: inherit;
  bottom: 15px;
  border: 2px #fff solid;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 1.1px;
  opacity: 0;
}

*:focus {
  outline: white;
}

.chk-btn {
  color: #1870c1 !important;
}

input.chk-btn {
  display: none;
}
input.chk-btn + label {
  border: 1px solid grey;
  background: ghoswhite;
  padding: 5px 8px;
  cursor: pointer;
  border-radius: 5px;
}
input.chk-btn:not(:checked) + label:hover {
  box-shadow: 0px 1px 3px;
}
input.chk-btn + label:active,
input.chk-btn:checked + label {
  box-shadow: 0px 0px 3px inset;
  background: #1870c1;
  color: #fff;
}

.partner {
  margin-top: 25px;
}

.checkboxButton {
  margin-right: 15px;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999 !important;
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed;
}

/*.swal2-html-container {
  font-weight: 900;
  color: black;
}*/
</style>

